import { useOutletContext, useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import {
    Container,
    Row,
    Col,
    Form,
    Button,
    Tabs,
    Tab,
    Table,
    Spinner,
    Card,
    Modal
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons'
import { faArrowRotateLeft } from '@fortawesome/free-solid-svg-icons'
import { faDeleteLeft } from '@fortawesome/free-solid-svg-icons'
import { faUserCheck } from '@fortawesome/free-solid-svg-icons'
import PaginationComponent from '../components/pagination/PaginationComponent.js'
import { useAuth0 } from "@auth0/auth0-react";
import { apiGet, apiPut, apiPost } from "../services/AuthService.js";
//custom gold theme styling
import {
    btnGold, btnGoldHover, FOCUS_GOLD, COLORS,
    header, footer, goldLinkBase, addUnderline, removeUnderline,
    boxshadowHover, boxshadowUnHover,
    showAdvancedBtn, searchBtn, uploadBtn, resetFiltersBtn, sourceDataBtn,
    statusColors, darkStatusColors,
    formLabel, columnTitle, columnSortLink, goldInputFocus, statusLabel,
    frame, goldFaPlus, faIconStyle,
    inputSm, paginationStyle, activePaginationStyle,
    dropDownToggle, dropDownInput, dropDownMenu, tableRowHover, tableRowUnHover,
    resetBtnGrey, stickyThStyle, adminStickyThStyle, filterActiveIndicator, backBtn
} from '../styles/goldTheme.js'

function LoadingRow({ colSpan = 12 }) {
    return (
        <tr>
            <td colSpan={colSpan} className="text-center">
                <Spinner animation="border" style={{ color: COLORS.gold }} />
            </td>
        </tr>
    )
}

const AccountSettings = (props) => {
    const baseUrl = process.env.REACT_APP_API_BASEURL;
    const { getAccessTokenSilently } = useAuth0();
    const navigate = useNavigate();

    const [
        currentAccount,
        accountProfile,
        setAccountProfile,
        toggleIsShowSidebarMd,
        setIsShowSidebarMd
    ] = useOutletContext();

    const [dataStatus, setDataStatus] = useState('');
    const [rowCount, setRowCount] = useState(0);
    const [userRowCount, setUserRowCount] = useState(0);
    const [pageStatus, setPageStatus] = useState('loading');
    const [pageErrors, setPageErrors] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [hoveredBtn, setHoveredBtn] = useState(null);
    const [screenHeight, setScreenHeight] = useState(100);

    const [accountId, setAccountId] = useState(0);
    const [companyName, setCompanyName] = useState('');
    const location = useLocation(); //for re-routing from admin dash

    const [pageDTO, setPageDTO] = useState(null);
    const [primaryCompany, setPrimaryCompany] = useState([]);
    const [operatorInfo, setOperatorInfo] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [users, setUsers] = useState([]);

    const emailRegex = RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);
    const [userEmailError, setUserEmailError] = useState("");
    const [companyEmailError, setCompanyEmailError] = useState("");
    const [isCheckingUserEmail, setIsCheckingUserEmail] = useState(false);
    const [userEmailExistsError, setUserEmailExistsError] = useState("");

    const [editing, setEditing] = useState({
        rowId: null,
        field: null,
        value: "",
    });

    const [accountDraft, setAccountDraft] = useState({
        primaryCompanyInfo: null,
        operatorInfo: null,
        nonOperatorInfo: null,
    });

    const [accountDirty, setAccountDirty] = useState(false);

    // Raw text while user is typing in the Billing Rate input. null means "not editing,
    // show the formatted model value". Keeps trailing zeros visible (e.g. "0.30" stays "0.30")
    // without interfering with the numeric model used for save/dirty-checking.
    const [billingRateText, setBillingRateText] = useState(null);

    const changedFieldStyle = {
        border: "1px solid #dc3545",
        boxShadow: "0 0 0 0.2rem rgba(220,53,69,0.15)",
    };

    const isFieldChanged = (section, field) => {
        if (!pageDTO || !accountDraft[section] || !pageDTO[section]) return false;
        return (accountDraft[section][field] ?? "") !== (pageDTO[section][field] ?? "");
    };

    const [typeError, setTypeError] = useState('');
    const [jibFormatError, setJibFormatError] = useState('');
    const [revenueFormatWarning, setRevenueFormatWarning] = useState('');
    const [docConvFormatWarning, setDocConvFormatWarning] = useState('');
    const [memberStatusWarning, setMemberStatusWarning] = useState('');
    const [companyCodeWarning, setCompanyCodeWarning] = useState("");

    const [showCompanyAddressModal, setShowCompanyAddressModal] = useState(false);
    const [addressCompanyId, setAddressCompanyId] = useState(null);
    const [addressOriginal, setAddressOriginal] = useState({
        companyAddress1: "",
        companyAddress2: "",
        companyAddress3: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        phone: "",
        email: "",
        fax: "",
    });
    const [companyAddressWarning, setCompanyAddressWarning] = useState("");
    const [addressDraft, setAddressDraft] = useState({
        companyAddress1: "",
        companyAddress2: "",
        companyAddress3: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        phone: "",
        email: "",
        fax: "",
    });

    const [showCreateUserModal, setShowCreateUserModal] = useState(false);
    const [createUserEmailError, setCreateUserEmailError] = useState("");
    const [createUserDraft, setCreateUserDraft] = useState({
        email: "",
        firstName: "",
        lastName: "",
        companyAddress1: "",
        companyAddress2: "",
        companyAddress3: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        phone: "",
        fax: "",
    });
    const[isCreatingUser, setIsCreatingUser] = useState(false);
    const [createUserGeneralError, setCreateUserGeneralError] = useState("");


    const [showPasswordResetModal, setShowPasswordResetModal] = useState(false);
    const [passwordResetUser, setPasswordResetUser] = useState(null);
    const [passwordResetMessage, setPasswordResetMessage] = useState(null);

    const [showDeleteUserModal, setShowDeleteUserModal] = useState(false);
    const [deleteUserUser, setDeleteUserUser] = useState(null);

    const [showActivateUserModal, setShowActivateUserModal] = useState(false);
    const [activateUserUser, setActivateUserUser] = useState(null);

    const [addressCompanyName, setAddressCompanyName] = useState("");

    const [rowMsgByKey, setRowMsgByKey] = useState({});
    const rowMsgTimersRef = useRef({});

    const [mergeToSearch, setMergeToSearch] = useState({ internalId: "", companyName: "" });
    const [mergeToResults, setMergeToResults] = useState([]);
    const [mergeToSelected, setMergeToSelected] = useState(null);
    const [mergeFromDetails, setMergeFromDetails] = useState(null);
    const [mergeToDetails, setMergeToDetails] = useState(null);
    const [showMergeConfirmModal, setShowMergeConfirmModal] = useState(false);
    const [isMergeSearching, setIsMergeSearching] = useState(false);
    const mergeToSearchRef = useRef(null);
    const [mergeResult, setMergeResult] = useState(null);
    const [isMergeExecuting, setIsMergeExecuting] = useState(false);

    const isMergeTabEnabled = (baseUrl && (baseUrl.includes("local") || baseUrl.includes("dev") || baseUrl.includes("qa") || baseUrl.includes("totdata-api.azurewebsites.net")));

    //initialize page
    useEffect(() => {
        (async () => {
            //for re-routing from admin dash
            if (location.state?.accountId) {
                setAccountId(location.state.accountId);
                setCompanyName(location.state.companyName);
            }

            console.log("Account Id: " + accountId + "\nCompany Name: " + companyName)

            if (setIsShowSidebarMd && accountProfile.accountId === "1") {
                setIsShowSidebarMd(false);
            }

            const height = window.innerHeight;
            setScreenHeight(height);

            setPageStatus('ready')

        })();
    }, [window.innerHeight]);

    const loadAccountSettingsPage = async (id, { showLoadingState = true } = {}) => {
        if (!id) return;
        if (showLoadingState) setDataStatus("loading");
        try {
            const apiUrl =
                'a_report/accountSettingsPage?' +
                '&accountId=' + id;

            const response = await apiGet(apiUrl, getAccessTokenSilently);

            if (!response.ok) throw new Error(await response.text());

            const dto = await response.json();

            setPageDTO(dto);
            setPrimaryCompany(dto.primaryCompanyInfo);
            setOperatorInfo(dto.operatorInfo);
            setCompanies(dto.companies || []);
            setUsers(dto.users || []);

            if (showLoadingState) setDataStatus("ready");
        } catch (e) {
            if (showLoadingState) setDataStatus("error");
            console.error(e);
        }
    };

    //grab account data based on account id
    useEffect(() => {
        if (!accountId) return;
        loadAccountSettingsPage(accountId);
    }, [accountId]);

    useEffect(() => {
        if (!pageDTO) return;

        setAccountDraft({
            primaryCompanyInfo: pageDTO.primaryCompanyInfo ?? null,
            operatorInfo: pageDTO.operatorInfo ?? null,
            nonOperatorInfo: pageDTO.nonOperatorInfo ?? null,
        });

        setAccountDirty(false);
    }, [pageDTO]);

    const getCompanyKey = (c) => (c.internalId ?? c.id);

    const openAddressModal = (company) => {
        const draft = {
            companyAddress1: company.companyAddress1 ?? "",
            companyAddress2: company.companyAddress2 ?? "",
            companyAddress3: company.companyAddress3 ?? "",
            city: company.city ?? "",
            state: company.state ?? "",
            zip: company.zip ?? "",
            country: company.country ?? "",
            phone: company.phone ?? "",
            email: company.email ?? "",
            fax: company.fax ?? "",
        };

        setCompanyEmailError("");
        setCompanyAddressWarning("");
        setAddressCompanyName(company.companyName ?? "");
        setAddressCompanyId(company.internalId);
        setAddressDraft(draft);
        setAddressOriginal(draft);
        setShowCompanyAddressModal(true);
    };

    const closeAddressModal = () => {
        setCompanyEmailError("");
        setCompanyAddressWarning("");
        setAddressCompanyName("");
        setShowCompanyAddressModal(false);
        setAddressCompanyId(null);
        setAddressDraft({
            companyAddress1: "",
            companyAddress2: "",
            companyAddress3: "",
            city: "",
            state: "",
            zip: "",
            country: "",
            phone: "",
            email: "",
            fax: "",
        });
        setAddressOriginal({
            companyAddress1: "",
            companyAddress2: "",
            companyAddress3: "",
            city: "",
            state: "",
            zip: "",
            country: "",
            phone: "",
            email: "",
            fax: "",
        });
    };

    const openPasswordResetModal = (user) => {
        setPasswordResetUser(user);
        setShowPasswordResetModal(true);
    }

    const closePasswordResetModal = () => {
        setShowPasswordResetModal(false);
        setPasswordResetUser(null);
        setPasswordResetMessage(null);
    }

    const openDeleteUserModal = (user) => {
        setDeleteUserUser(user);
        setShowDeleteUserModal(true);
    }

    const closeDeleteUserModal = () => {
        setShowDeleteUserModal(false);
        setDeleteUserUser(false);
    }

    const openActivateUserModal = (user) => {
        setActivateUserUser(user);
        setShowActivateUserModal(true);
    }

    const closeActivateUserModal = () => {
        setShowActivateUserModal(false);
        setActivateUserUser(false);
    }

    const openCreateUserModal = () => {
        setCreateUserEmailError("");
        setCreateUserGeneralError("");
        setIsCreatingUser(false); 
        setCreateUserDraft({
            email: "",
            firstName: "",
            lastName: "",
            companyAddress1: primaryCompany?.address1 ?? "",
            companyAddress2: primaryCompany?.address2 ?? "",
            companyAddress3: primaryCompany?.address3 ?? "",
            city: primaryCompany?.city ?? "",
            state: primaryCompany?.state ?? "",
            zip: primaryCompany?.zip ?? "",
            country: primaryCompany?.country ?? "",
            phone: primaryCompany?.phone ?? "",
            fax: primaryCompany?.fax ?? "",
        });
        setShowCreateUserModal(true);
    };

    const closeCreateUserModal = () => {
        setShowCreateUserModal(false);
        setCreateUserEmailError("");
        setCreateUserGeneralError("");
        setIsCreatingUser(false);
        setCreateUserDraft({
            email: "",
            firstName: "",
            lastName: "",
            companyAddress1: "",
            companyAddress2: "",
            companyAddress3: "",
            city: "",
            state: "",
            zip: "",
            country: "",
            phone: "",
            fax: "",
        });
    };

    const addressChangedFieldStyle = {
        border: "1px solid #dc3545",
        boxShadow: "0 0 0 0.2rem rgba(220,53,69,0.15)",
    };

    const isAddressFieldChanged = (field) => {
        return (addressDraft?.[field] ?? "") !== (addressOriginal?.[field] ?? "");
    };

    const isAddressDirty = () => {
        return (
            isAddressFieldChanged("companyAddress1") ||
            isAddressFieldChanged("companyAddress2") ||
            isAddressFieldChanged("companyAddress3") ||
            isAddressFieldChanged("city") ||
            isAddressFieldChanged("state") ||
            isAddressFieldChanged("zip") ||
            isAddressFieldChanged("country") ||
            isAddressFieldChanged("phone") ||
            isAddressFieldChanged("email") ||
            isAddressFieldChanged("fax")
        );
    };

    const makeRowMsgKey = (rowId, field) => `${rowId}:${field}`;

    const showRowMsg = (rowId, field, type, text, length = 7000) => {
        const key = makeRowMsgKey(rowId, field);

        if (rowMsgTimersRef.current[key]) {
            clearTimeout(rowMsgTimersRef.current[key]);
        }

        setRowMsgByKey((prev) => ({
            ...prev,
            [key]: { type, text }
        }));

        rowMsgTimersRef.current[key] = setTimeout(() => {
            setRowMsgByKey((prev) => {
                const next = { ...prev };
                delete next[key];
                return next;
            });
            delete rowMsgTimersRef.current[key];
        }, length);
    };

    const showRowSuccess = (rowId, field, text, length) => showRowMsg(rowId, field, "success", text, length);
    const showRowError = (rowId, field, text, length) => showRowMsg(rowId, field, "error", text, length);

    const RowMsg = ({ rowId, field }) => {
        const key = makeRowMsgKey(rowId, field);
        const msg = rowMsgByKey[key];
        if (!msg) return null;

        const color = msg.type === "success" ? "green" : msg.type === "error" ? "#dc3545" : "#6c757d";

        return (
            <div style={{ marginTop: 4, fontSize: 12, color, fontWeight: 600 }}>
                {msg.text}
            </div>
        );
    };

    const clearRowMsg = (rowId, field) => {
        const key = makeRowMsgKey(rowId, field);

        if (rowMsgTimersRef.current[key]) {
            clearTimeout(rowMsgTimersRef.current[key]);
            delete rowMsgTimersRef.current[key];
        }

        setRowMsgByKey((prev) => {
            const next = { ...prev };
            delete next[key];
            return next;
        });
    };

    const saveCompanyAddress = async () => {
        const companyId = addressCompanyId;
        if (!companyId) return;

        if (companyEmailError) return;

        const nextValue = {
            companyAddress1: (addressDraft.companyAddress1 ?? "").trim(),
            companyAddress2: (addressDraft.companyAddress2 ?? "").trim(),
            companyAddress3: (addressDraft.companyAddress3 ?? "").trim(),
            city: (addressDraft.city ?? "").trim(),
            state: (addressDraft.state ?? "").trim(),
            zip: (addressDraft.zip ?? "").trim(),
            country: (addressDraft.country ?? "").trim(),
            phone: (addressDraft.phone ?? "").trim(),
            email: (addressDraft.email ?? "").trim(),
            fax: (addressDraft.fax ?? "").trim(),
        };

        if (!nextValue.email) {
            setCompanyEmailError("Email is required.");
            return;
        }

        const originalValue = {
            companyAddress1: (addressOriginal.companyAddress1 ?? "").trim(),
            companyAddress2: (addressOriginal.companyAddress2 ?? "").trim(),
            companyAddress3: (addressOriginal.companyAddress3 ?? "").trim(),
            city: (addressOriginal.city ?? "").trim(),
            state: (addressOriginal.state ?? "").trim(),
            zip: (addressOriginal.zip ?? "").trim(),
            country: (addressOriginal.country ?? "").trim(),
            phone: (addressOriginal.phone ?? "").trim(),
            email: (addressOriginal.email ?? "").trim(),
            fax: (addressOriginal.fax ?? "").trim(),
        };

        const hasChanges =
            nextValue.companyAddress1 !== originalValue.companyAddress1 ||
            nextValue.companyAddress2 !== originalValue.companyAddress2 ||
            nextValue.companyAddress3 !== originalValue.companyAddress3 ||
            nextValue.city !== originalValue.city ||
            nextValue.state !== originalValue.state ||
            nextValue.zip !== originalValue.zip ||
            nextValue.country !== originalValue.country ||
            nextValue.phone !== originalValue.phone ||
            nextValue.email !== originalValue.email ||
            nextValue.fax !== originalValue.fax;

        if (!hasChanges) {
            setCompanyAddressWarning("No changes to save.");
            return;
        }

        setCompanies((prev) =>
            prev.map((row) =>
                row.internalId === companyId
                    ? {
                        ...row,
                        companyAddress1: nextValue.companyAddress1,
                        companyAddress2: nextValue.companyAddress2,
                        companyAddress3: nextValue.companyAddress3,
                        city: nextValue.city,
                        state: nextValue.state,
                        zip: nextValue.zip,
                        country: nextValue.country,
                        phone: nextValue.phone,
                        email: nextValue.email,
                        fax: nextValue.fax,
                    }
                    : row
            )
        );

        try {
            await updateCompanyAddress(companyId, nextValue);

            closeAddressModal();
            showRowSuccess(companyId, "companyAddress1", "Company address successfully updated.");
        } catch (e) {
            setCompanies((prev) =>
                prev.map((row) =>
                    row.internalId === companyId
                        ? {
                            ...row,
                            companyAddress1: originalValue.companyAddress1,
                            companyAddress2: originalValue.companyAddress2,
                            companyAddress3: originalValue.companyAddress3,
                            city: originalValue.city,
                            state: originalValue.state,
                            zip: originalValue.zip,
                            country: originalValue.country,
                            phone: originalValue.phone,
                            email: originalValue.email,
                            fax: originalValue.fax,
                        }
                        : row
                )
            );

            showRowError(companyId, "companyAddress1", "Failed to save company address.");
        }
    };

    const updateCompanyAddress = async (companyId, address) => {
        const apiUrl = `Companies/${companyId}/companyAddress`;

        const jsonBody = JSON.stringify({
            companyAddress1: address.companyAddress1,
            companyAddress2: address.companyAddress2,
            companyAddress3: address.companyAddress3,
            city: address.city,
            state: address.state,
            zip: address.zip,
            country: address.country,
            phone: address.phone,
            email: address.email,
            fax: address.fax,
        });

        const response = await apiPut(apiUrl, jsonBody, getAccessTokenSilently);
        return response;
    };

    const saveUserEmailEdit = async (user) => {
        const newEmail = (editing.value ?? "").trim();
        if (!newEmail || !emailRegex.test(newEmail)) return;

        setIsCheckingUserEmail(true);
        setUserEmailExistsError("");

        try {
            const resp = await verifyEmailAvailable(user.userProfileId, user, newEmail);

            if (resp.status === 204) {
                const response = await updateAuth0Email(user.userProfileId, user, newEmail);

                if (response.status === 204) {
                    setUsers((prev) =>
                        prev.map((u) =>
                            u.internalId === user.internalId
                                ? { ...u, userEmail: newEmail }
                                : u
                        )
                    );
                    cancelEdit();
                    showRowSuccess(user.internalId, "userEmail", "Email successfully updated.")

                    return;
                }

                const err = await response.text();
                setUserEmailExistsError(err || "Unable to update email in Auth0/DB.");
                return;
            }

            if (resp.status === 409) {
                const msg = await resp.text();
                setUserEmailExistsError(msg || "Email already exists.");
                return;
            }

            const err = await resp.text();
            setUserEmailExistsError(err || "Unable to validate email against Auth0.");
        } catch (e) {
            console.error(e);
            setUserEmailExistsError("Unable to validate email against Auth0.");
        } finally {
            setIsCheckingUserEmail(false);
        }
    };

    const verifyEmailAvailable = async (userProfileId, user, newEmail) => {
        const apiUrl = `UserProfiles/${userProfileId}/VerifyEmailAvailable?newEmail=${encodeURIComponent(newEmail)}`;

        const jsonBody = JSON.stringify(user);

        return await apiPut(apiUrl, jsonBody, getAccessTokenSilently);
    };

    const updateAuth0Email = async (userProfileId, user, newEmail) => {
        const apiUrl = `UserProfiles/${userProfileId}/UpdateAuth0Email?newEmail=${encodeURIComponent(newEmail)}`;

        const jsonBody = JSON.stringify(user);

        return await apiPut(apiUrl, jsonBody, getAccessTokenSilently);
    };

    const createNewUser = async (payload) => {
        const apiUrl = `Accounts/AdminCreateUser`;
        const jsonBody = JSON.stringify(payload);
        return await apiPut(apiUrl, jsonBody, getAccessTokenSilently);
    };

    const saveNewUser = async () => {
        if (!createUserDraft.email || !emailRegex.test(createUserDraft.email)) {
            setCreateUserEmailError("A valid email is required.");
            return;
        }
        if (!createUserDraft.firstName.trim()) return;
        if (!createUserDraft.lastName.trim()) return;

        const payload = {
            accountId,
            email: createUserDraft.email.trim(),
            firstName: createUserDraft.firstName.trim(),
            lastName: createUserDraft.lastName.trim(),
            companyAddress1: createUserDraft.companyAddress1.trim(),
            companyAddress2: createUserDraft.companyAddress2.trim(),
            companyAddress3: createUserDraft.companyAddress3.trim(),
            city: createUserDraft.city.trim(),
            state: createUserDraft.state.trim(),
            zip: createUserDraft.zip.trim(),
            country: createUserDraft.country.trim(),
            phone: createUserDraft.phone.trim(),
            fax: createUserDraft.fax.trim(),
        };

        setIsCreatingUser(true);
        setCreateUserEmailError("");
        setCreateUserGeneralError("");

        try {
            const response = await createNewUser(payload);

            if (response.status === 204) {
                const refreshUrl = 'a_report/accountSettingsPage?&accountId=' + accountId;
                const refreshResponse = await apiGet(refreshUrl, getAccessTokenSilently);
                if (refreshResponse.ok) {
                    const dto = await refreshResponse.json();
                    setUsers(dto.users || []);
                }

                closeCreateUserModal();
            } else {
                const errText = await response.text();
                switch (errText) {
                    case "EmailAlreadyExists":
                        setCreateUserEmailError("An account with this email already exists.");
                        break;
                    case "AccountNotFound":
                        setCreateUserGeneralError("Account not found. Please refresh and try again.");
                        break;
                    case "PrimaryCompanyNotFound":
                        setCreateUserGeneralError("No primary company found for this account.");
                        break;
                    default:
                        setCreateUserGeneralError("An unexpected error occurred. Please try again.");
                }
            }
        } catch (e) {
            console.error(e);
            setCreateUserGeneralError("An unexpected error occurred. Please try again.");
        } finally {
            setIsCreatingUser(false);
        }
    };


    const handleCompanyChange = async (id) => {
        //const fieldName = event.target.name;
        const value = id;
        //console.log('Field: ' + fieldName + ', Value: ' + value);

        //setSelectedAccountId(value);
        setDataStatus('loading');

        await getAccountSwitch(value)
            .then(response => {
                if (response.success) {
                    localStorage.removeItem('dataFileState');

                    //refresh site at admin dashboard page with new token
                    window.location.href = window.location.origin;
                } else {
                    //setAllCompanies([]);
                }
            })
            .catch(ex => {
                //setPageStatus('error');
                //setPageErrors(ex.message);
            })
            .finally(response => {
                setDataStatus('ready');
            })
    };

    //get account switch
    const getAccountSwitch = async (accountId) => {
        //console.log('Switching Account...');

        const apiUrl = 'accounts/accountswitch/' + accountId;
        //console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = response.ok ? await response.json() : [];
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, data: json };
    };

    const markAccountDirty = () => setAccountDirty(true);

    const beginEditCompanyCode = (company) => {
        if (isOperatorCompany(company)) {
            setCompanyCodeWarning("Warning: Changing Company # impacts operator processing.");
        } else {
            setCompanyCodeWarning("");
        }

        beginEditUserEmail(company.internalId, "companyCode", company.companyCode);
    };

    const beginEditUserEmail = (rowId, field, currentValue) => {
        clearRowMsg(rowId, "userEmail")
        setUserEmailError("");
        setUserEmailExistsError("");
        setEditing({
            rowId,
            field,
            value: currentValue ?? "",
            originalValue: currentValue ?? ""
        });
    };

    const cancelEdit = () => {
        setCompanyCodeWarning("");
        setUserEmailError("");
        setUserEmailExistsError("");
        setIsCheckingUserEmail(false);
        setEditing({
            rowId: null,
            field: null,
            value: "",
            originalValue: ""
        });
    };

    //later replace with api calls
    const saveEditLocal = (setList) => {
        setList((prev) =>
            prev.map((row) =>
                row.internalId === editing.rowId
                    ? { ...row, [editing.field]: editing.value }
                    : row
            )
        );
        cancelEdit();
    };

    const saveCompanyCode = async () => {
        const companyId = editing?.rowId;
        if (!companyId) return;

        const nextValue = (editing?.value ?? "").trim();
        const originalValue = (editing?.originalValue ?? "").trim();

        if (nextValue === originalValue) {
            setCompanyCodeWarning("No change to save.");
            return;
        }

        if (!nextValue) {
            setCompanyCodeWarning("Company # cannot be empty.");
            return;
        }

        setCompanies((prev) =>
            prev.map((row) =>
                row.internalId === companyId ? { ...row, companyCode: nextValue } : row
            )
        );

        try {
            await updateCompanyCode(companyId, nextValue);

            cancelEdit();
            showRowSuccess(companyId, "companyCode", "Company # successfully updated.");
        } catch (e) {
            setCompanies((prev) =>
                prev.map((row) =>
                    row.internalId === companyId ? { ...row, companyCode: originalValue } : row
                )
            );

            showRowError(companyId, "companyCode", "Failed to save Company #.");
        }
    };

    const updateCompanyCode = async (companyId, newCompanyCode) => {
        const apiUrl = `Companies/${companyId}/companyCode`;
        const jsonBody = JSON.stringify({ companyCode: newCompanyCode });
        const response = await apiPut(apiUrl, jsonBody, getAccessTokenSilently);
        return response;
    };

    const saveAccountingSystem = async () => {
        if (!accountId) return;

        const nextValue = accountDraft.primaryCompanyInfo?.clientAccountingSystemId ?? null;
        const originalValue = pageDTO?.primaryCompanyInfo?.clientAccountingSystemId ?? null;

        if (nextValue === originalValue) return;

        try {
            await updateAccountingSystem(accountId, nextValue);

            setPageDTO((prev) => ({
                ...prev,
                primaryCompanyInfo: {
                    ...prev.primaryCompanyInfo,
                    clientAccountingSystemId: nextValue,
                },
            }));

            showRowSuccess(accountId, "clientAccountingSystemId", "Accounting system successfully updated.");
        } catch (e) {
            setAccountDraft((prev) => ({
                ...prev,
                primaryCompanyInfo: {
                    ...prev.primaryCompanyInfo,
                    clientAccountingSystemId: originalValue,
                },
            }));

            showRowError(accountId, "clientAccountingSystemId", "Failed to save accounting system.");
        }
    };

    const updateAccountingSystem = async (accountId, clientAccountingSystemId) => {
        const apiUrl = `Companies/${accountId}/clientAccountingSystem`;
        const jsonBody = JSON.stringify({ clientAccountingSystemId }); 
        const response = await apiPut(apiUrl, jsonBody, getAccessTokenSilently);
        if (!response.ok) throw new Error(await response.text());
        return response;
    };

    const saveEnergyDomain = async () => {
        if (!accountId) return;

        const nextValue = accountDraft.primaryCompanyInfo?.energyDomain ?? "N";
        const originalValue = pageDTO?.primaryCompanyInfo?.energyDomain ?? "N";

        if (nextValue === originalValue) return;

        try {
            await updateEnergyDomain(accountId, nextValue);

            setPageDTO((prev) => ({
                ...prev,
                primaryCompanyInfo: {
                    ...prev.primaryCompanyInfo,
                    energyDomain: nextValue,
                },
            }));

            showRowSuccess(accountId, "energyDomain", "Energy domain successfully updated.");
        } catch (e) {
            setAccountDraft((prev) => ({
                ...prev,
                primaryCompanyInfo: {
                    ...prev.primaryCompanyInfo,
                    energyDomain: originalValue,
                },
            }));

            showRowError(accountId, "energyDomain", "Failed to save energy domain.");
        }
    };

    const updateEnergyDomain = async (accountId, energyDomain) => {
        const apiUrl = `Companies/${accountId}/energyDomain`;
        const jsonBody = JSON.stringify({ energyDomain });
        const response = await apiPut(apiUrl, jsonBody, getAccessTokenSilently);
        if (!response.ok) throw new Error(await response.text());
        return response;
    };

    const saveJibFormat = async () => {
        if (!accountId) return;
        const nextValue = accountDraft.operatorInfo?.jibFormatId ?? null;
        const originalValue = pageDTO?.operatorInfo?.jibFormatId ?? null;
        if (nextValue === originalValue) return;
        try {
            await updateJibFormat(accountId, nextValue);
        } catch (e) {
            setAccountDraft((prev) => ({
                ...prev,
                operatorInfo: { ...prev.operatorInfo, jibFormatId: originalValue },
            }));
            throw e;
        }
    };

    const updateJibFormat = async (accountId, jibFormatId) => {
        const apiUrl = `Accounts/${accountId}/jibFormat`;
        const jsonBody = JSON.stringify({ jibAccountingSystemId: jibFormatId });
        const response = await apiPut(apiUrl, jsonBody, getAccessTokenSilently);
        if (!response.ok) throw new Error(await response.text());
        return response;
    };

    const saveRevenueFormat = async () => {
        if (!accountId) return;
        const nextValue = accountDraft.operatorInfo?.revenueFormatId ?? null;
        const originalValue = pageDTO?.operatorInfo?.revenueFormatId ?? null;
        if (nextValue === originalValue) return;
        try {
            await updateRevenueFormat(accountId, nextValue);
        } catch (e) {
            setAccountDraft((prev) => ({
                ...prev,
                operatorInfo: { ...prev.operatorInfo, revenueFormatId: originalValue },
            }));
            throw e;
        }
    };

    const updateRevenueFormat = async (accountId, revenueFormatId) => {
        const apiUrl = `Accounts/${accountId}/revenueFormat`;
        const jsonBody = JSON.stringify({ accountingSystemId: revenueFormatId });
        const response = await apiPut(apiUrl, jsonBody, getAccessTokenSilently);
        if (!response.ok) throw new Error(await response.text());
        return response;
    };

    const reActivateUser = async () => {
        try {
            await updateUserStatus(activateUserUser.userProfileId, activateUserUser, true);

            setUsers((prev) =>
                prev.map((u) =>
                    u.internalId === activateUserUser.internalId
                        ? { ...u, isActive: true }
                        : u
                )
            );

            closeActivateUserModal();
            showRowSuccess(activateUserUser.internalId, "reActivateUser", "User status successfully updated.");
        } catch (e) {

            showRowError(activateUserUser.internalId, "reActivateUser", "Failed to update user status.");
        }
    }

    const deleteUser = async () => {
        try {
            await updateUserStatus(deleteUserUser.userProfileId, deleteUserUser, false);

            setUsers((prev) =>
                prev.map((u) =>
                    u.internalId === deleteUserUser.internalId
                        ? { ...u, isActive: false }
                        : u
                )
            );

            closeDeleteUserModal();
            showRowSuccess(deleteUserUser.internalId, "deleteUser", "User status successfully updated.");
        } catch (e) {

            showRowError(deleteUserUser.internalId, "deleteUser", "Failed to update user status.");
        }
    }

    const updateUserStatus = async (userProfileId, user, newStatus) => {
        const apiUrl = `Accounts/${userProfileId}/UpdateUserStatus?newStatus=${encodeURIComponent(newStatus)}`;

        const jsonBody = JSON.stringify(user);

        return await apiPut(apiUrl, jsonBody, getAccessTokenSilently);
    };

    const resetUserPassword = async () => {
        if (!passwordResetUser) return;

        try {
            const resp = await sendPasswordReset(passwordResetUser.userProfileId, passwordResetUser);

            if (resp.status === 204) {
                setPasswordResetMessage({ type: "success", text: "Password reset email sent successfully." });
                return;
            }

            const errText = await resp.text();

            if (resp.status === 409) {
                setPasswordResetMessage({ type: "error", text: errText || "Unable to send password reset." });
                return;
            }

            setPasswordResetMessage({ type: "error", text: errText || "Unable to send password reset to user." });

        } catch (e) {
            console.error(e);
            setPasswordResetMessage({ type: "error", text: "An unexpected error occurred." });
        }
    };

    const sendPasswordReset = async (userProfileId, user) => {
        const apiUrl = `Accounts/${userProfileId}/SendPasswordReset`;

        const jsonBody = JSON.stringify(user);

        return await apiPut(apiUrl, jsonBody, getAccessTokenSilently);
    };

    const isEditing = (rowId, field) => editing.rowId === rowId && editing.field === field;

    const scrollContainerRef = useRef(null);
    function getCompanyTypeName(companyTypeId) {
        switch (companyTypeId) {
            case 1:
                return 'Operator';
            case 4:
                return 'Owner'
            default:
                return companyTypeId?.toString() ?? "";
        }
    }

    const isDocConvChanged = () => {
        if (!pageDTO?.nonOperatorInfo || !accountDraft?.nonOperatorInfo) return false;
        const a = accountDraft.nonOperatorInfo;
        const b = pageDTO.nonOperatorInfo;
        return (
            (a.docConversionNetworkTypeId ?? null) !== (b.docConversionNetworkTypeId ?? null) ||
            (a.docConversionJIBOutputTypeId ?? null) !== (b.docConversionJIBOutputTypeId ?? null) ||
            (a.docConversionRevenueOutputTypeId ?? null) !== (b.docConversionRevenueOutputTypeId ?? null) ||
            (a.documentConversionBillingRate ?? null) !== (b.documentConversionBillingRate ?? null)
        );
    };

    const saveDocConv = async () => {
        if (!accountId) return;
        if (!isDocConvChanged()) return;
        const next = accountDraft.nonOperatorInfo;
        const orig = pageDTO?.nonOperatorInfo;
        try {
            await updateDocConv(accountId, {
                docConversionNetworkTypeId: next?.docConversionNetworkTypeId ?? null,
                docConversionJIBOutputTypeId: next?.docConversionJIBOutputTypeId ?? null,
                docConversionRevenueOutputTypeId: next?.docConversionRevenueOutputTypeId ?? null,
                documentConversionBillingRate: next?.documentConversionBillingRate ?? null,
            });
        } catch (e) {
            setAccountDraft((prev) => ({ ...prev, nonOperatorInfo: orig }));
            throw e;
        }
    };

    const updateDocConv = async (accountId, payload) => {
        const apiUrl = `Accounts/${accountId}/docConversion`;
        const jsonBody = JSON.stringify(payload);
        const response = await apiPut(apiUrl, jsonBody, getAccessTokenSilently);
        if (!response.ok) throw new Error(await response.text());
        return response;
    };

    const isOperatorCompany = (company) => Number(company.companyType) === 1;

    const docConvJibValue = (() => {
        const networkId = accountDraft?.nonOperatorInfo?.docConversionNetworkTypeId;
        if (networkId == null) return "";
        if (networkId === 1) return "N1";
        if (networkId === 3) return "N3";
        const outputId = accountDraft?.nonOperatorInfo?.docConversionJIBOutputTypeId;
        return outputId != null ? `N2-O${outputId}` : "";
    })();

    const docConvRevenueValue = (() => {
        const networkId = accountDraft?.nonOperatorInfo?.docConversionNetworkTypeId;
        if (networkId == null) return "";
        if (networkId === 1) return "N1";
        if (networkId === 3) return "N3";
        const outputId = accountDraft?.nonOperatorInfo?.docConversionRevenueOutputTypeId;
        return outputId != null ? `N2-O${outputId}` : "";
    })();

    const searchMergeTo = async () => {
        const nameQuery = (mergeToSearch.companyName ?? "").trim();
        const idQuery = (mergeToSearch.internalId ?? "").trim();

        if (!nameQuery && !idQuery) return;

        setIsMergeSearching(true);
        setMergeToResults([]);
        setMergeToSelected(null);
        setMergeToDetails(null);

        try {
            const params = new URLSearchParams();
            if (idQuery) params.append("internalId", idQuery);
            if (nameQuery) params.append("companyName", nameQuery);

            const apiUrl = `a_report/MergeCompanySearch?${params.toString()}`;
            const response = await apiGet(apiUrl, getAccessTokenSilently);

            if (!response.ok) throw new Error(await response.text());

            const results = await response.json();
            setMergeToResults(results);
        } catch (e) {
            console.error("Merge search failed:", e);
        } finally {
            setIsMergeSearching(false);
        }
    };

    const selectMergeTo = (company) => {
        if (company?.isMergeable === false) return;
        setMergeToSelected(company);
        setMergeToResults([]);
        setMergeToSearch({ internalId: "", companyName: "" });

        setMergeToDetails({
            internalId: company.id,
            companyName: company.companyName,
            companyTypeName: company.companyTypeName,
            companyCode: company.companyCode,
            address1: company.address1 ?? "",
            address2: company.address2 ?? "",
            address3: company.address3 ?? "",
            city: company.city ?? "",
            state: company.state ?? "",
            country: company.country ?? "",
            zip: company.zip ?? "",
            status: company.status ?? "", 
            accountId: company.accountId,
        });
    };

    const buildMergeFromDetails = () => {
        //pull from primary company
        return {
            internalId: primaryCompany?.internalId ?? "",
            companyName: primaryCompany?.companyName ?? "",
            companyTypeName: getCompanyTypeName(primaryCompany?.type) ?? "",
            address1: primaryCompany?.address1 ?? "",
            address2: primaryCompany?.address2 ?? "",
            address3: primaryCompany?.address3 ?? "",
            city: primaryCompany?.city ?? "",
            state: primaryCompany?.state ?? "",
            country: primaryCompany?.country ?? "",
            zip: primaryCompany?.zip ?? "",
            status: "",
        };
    };

    const handleMergeConfirm = () => {
        if (!mergeToDetails) return;
        setMergeFromDetails(buildMergeFromDetails());
        setShowMergeConfirmModal(true);
    };

    const handleMergeExecute = async () => {
        setIsMergeExecuting(true);
        setMergeResult(null);
        try {
            const apiUrl = `Companies/MergeCompany`;
            const jsonBody = JSON.stringify({
                companyToMergeId: mergeToDetails.internalId,
                targetAccountId: accountId,
            });
            const response = await apiPut(apiUrl, jsonBody, getAccessTokenSilently);
            const result = await response.json();
            setMergeResult(result);
        } catch (e) {
            console.error(e);
            setMergeResult({
                overallSuccess: false,
                companyUpdateSuccess: false,
                companyUpdateError: "An unexpected error occurred.",
                accountSendersSuccess: false,
                accountSendersError: "An unexpected error occurred.",
                accountSendersAdded: 0,
            });
        } finally {
            setIsMergeExecuting(false);
        }
    };

    const closeMergeConfirmModal = () => {
        const wasSuccess = !!mergeResult?.companyUpdateSuccess;
        if (wasSuccess) {
            setMergeToDetails(null);
            setMergeToSelected(null);
            setMergeToResults([]);
            setMergeToSearch({ internalId: "", companyName: "" });
        }
        setShowMergeConfirmModal(false);
        setMergeResult(null);
        if (wasSuccess) {
            loadAccountSettingsPage(accountId, { showLoadingState: false });
        }
    };

    const MergeDetailTable = ({ details, label }) => (
        <div>
            {/* Tightened from fontSize 13/marginBottom 6 + 4px row padding to fit the merge tab without page scrolling */}
            <div style={{ fontWeight: 500, fontSize: 12, color: "#6c757d", marginBottom: 3 }}>{label}</div>
            <table style={{ width: "100%", fontSize: 12, borderCollapse: "collapse" }}>
                {[
                    ["Internal Id", details?.internalId ?? ""],
                    ["Company Name", details?.companyName ?? ""],
                    ["Company Type", details?.companyTypeName ?? ""],
                    ["Address 1", details?.address1 ?? ""],
                    ["Address 2", details?.address2 ?? ""],
                    ["Address 3", details?.address3 ?? ""],
                    ["City", details?.city ?? ""],
                    ["State", details?.state ?? ""],
                    ["Country", details?.country ?? ""],
                    ["Zip", details?.zip ?? ""],
                    ["Status", details?.status ?? ""],
                ].map(([label, value]) => (
                    <tr key={label} style={{ borderBottom: "1px solid #dee2e6" }}>
                        <td style={{ padding: "1px 8px", color: "#6c757d", width: "40%" }}>{label}</td>
                        <td style={{ padding: "1px 8px" }}>{value}</td>
                    </tr>
                ))}
            </table>
        </div>
    );

    return (
        <>
            <Row className="align-items-center">
                <Col
                    xs="auto"
                    style={{
                        marginLeft: '-7px',
                        paddingRight: 4,
                    }}
                >
                    <span
                        style={{ ...backBtn }}
                        onClick={() => navigate(-1)}
                    >
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </span>
                </Col>
                <Col>
                    <span style={{ fontWeight: 500, fontSize: '2rem', lineHeight: 1.2 }}>
                        Admin Dashboard
                    </span>
                </Col>
            </Row>
            {dataStatus === "loading" ? (
                <div className="body flex-grow-1 px-3">
                    <Container fluid>
                        <Row>
                            <Col>
                                <div style={{ marginLeft: 12, marginTop: 6 }}>
                                    <Spinner animation="border" style={{ color: COLORS.gold }} />
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            ) : (
                    <div className="body flex-grow-1 px-3">
                        <Container fluid>

                            <Row style={{ marginTop: '10px' }}>
                                <Tabs
                                    defaultActiveKey="accountsettings"
                                    id="admin-dashboard-tabs"
                                    className="mb-1"
                                    style={{
                                        '--bs-nav-link-color': '#000',
                                        '--bs-nav-link-hover-color': '#000',
                                        '--bs-nav-link-active-color': '#000',  
                                        '--bs-nav-link-active-bg': 'transparent',
                                    }}
                                >

                                    {/*** ACCOUNT SETTINGS ***/}
                                    <Tab eventKey="accountsettings" title="Account Settings">
                                        <Col>
                                            <span
                                                style={{
                                                    marginLeft: 12,
                                                    fontSize: 16,
                                                    fontWeight: 500,
                                                    color: "#6c757d"
                                                }}
                                            >
                                                {primaryCompany.companyName}&nbsp;&nbsp;
                                            </span>
                                            {(() => {
                                                if (accountId !== null) {
                                                    return (
                                                        <Button
                                                            variant="outline-primary"
                                                            size="sm"
                                                            onClick={() => handleCompanyChange(accountId)}
                                                            style={{
                                                                padding: "1px 6px",
                                                                lineHeight: 1,
                                                                height: 24,
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faSignInAlt} style={{ fontSize: 12 }} />
                                                        </Button>
                                                    );
                                                }
                                            })()}
                                        </Col>
                                        <Col>
                                            {accountDirty && (
                                                <div
                                                    style={{
                                                        position: "sticky",
                                                        top: 0,
                                                        zIndex: 5,
                                                        margin: "10px 12px",
                                                        padding: "10px 12px",
                                                        border: "1px solid #dc3545",
                                                        background: "rgba(220,53,69,0.06)",
                                                        borderRadius: 6,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        gap: 12,
                                                    }}
                                                >
                                                    <div style={{ color: "#dc3545", fontWeight: 600 }}>
                                                        You have unsaved changes.
                                                    </div>

                                                    <div style={{ display: "flex", gap: 8 }}>
                                                        <Button
                                                            size="sm"
                                                            variant="secondary"
                                                            type="button"
                                                            onClick={() => {
                                                                setAccountDraft({
                                                                    primaryCompanyInfo: pageDTO.primaryCompanyInfo ?? null,
                                                                    operatorInfo: pageDTO.operatorInfo ?? null,
                                                                    nonOperatorInfo: pageDTO.nonOperatorInfo ?? null,
                                                                });
                                                                setTypeError("");
                                                                setJibFormatError("");
                                                                setRevenueFormatWarning("");
                                                                setDocConvFormatWarning("");
                                                                setMemberStatusWarning("");
                                                                setAccountDirty(false);
                                                            }}
                                                        >
                                                            Cancel
                                                        </Button>

                                                        <Button
                                                            size="sm"
                                                            type="button"
                                                            onClick={async () => {
                                                                const saves = [];

                                                                if (isFieldChanged("primaryCompanyInfo", "clientAccountingSystemId"))
                                                                    saves.push(saveAccountingSystem());
                                                                if (isFieldChanged("primaryCompanyInfo", "energyDomain"))
                                                                    saves.push(saveEnergyDomain());
                                                                if (isFieldChanged("operatorInfo", "jibFormatId"))  
                                                                    saves.push(saveJibFormat());
                                                                if (isFieldChanged("operatorInfo", "revenueFormatId")) 
                                                                    saves.push(saveRevenueFormat());
                                                                if (isDocConvChanged())
                                                                    saves.push(saveDocConv());

                                                                const results = await Promise.allSettled(saves);
                                                                const anyFailed = results.some((r) => r.status === "rejected");

                                                                if (anyFailed) {
                                                                    return;
                                                                }

                                                                setPageDTO((prev) => ({
                                                                    ...prev,
                                                                    primaryCompanyInfo: accountDraft.primaryCompanyInfo,
                                                                    operatorInfo: accountDraft.operatorInfo,
                                                                    nonOperatorInfo: accountDraft.nonOperatorInfo,
                                                                }));
                                                                setTypeError("");
                                                                setJibFormatError("");
                                                                setRevenueFormatWarning("");
                                                                setDocConvFormatWarning("");
                                                                setMemberStatusWarning("");
                                                                setAccountDirty(false);
                                                            }}
                                                            style={
                                                                hoveredBtn && hoveredBtn?.type === 'search'
                                                                    ? { ...btnGold, ...btnGoldHover }
                                                                    : { ...btnGold }
                                                            }
                                                            onMouseEnter={() => setHoveredBtn({ type: 'search' })}
                                                            onMouseLeave={() => setHoveredBtn(null)}
                                                        >
                                                            Save
                                                        </Button>
                                                    </div>
                                                </div>
                                            )}
                                        </Col>
                                        <div
                                            ref={scrollContainerRef}
                                            style={{
                                                // No internal scroll — let the section size to its content. The density
                                                // reductions below (smaller dividers, tighter section spacing, smaller
                                                // row gutters) keep the page short enough to view all sections at once
                                                // on a normal viewport without internal scrolling.
                                            }}
                                        >
                                            {/*
                                                Scoped style block: compacts every Form.Control / Form.Select
                                                and shrinks Form.Group margins inside the Account Settings tab
                                                so the entire tab fits a typical desktop viewport without scrolling.
                                                The .account-settings-compact class isolates the rules so modals
                                                and other tabs are not affected.
                                            */}
                                            <style>{`
                                                .account-settings-compact .form-control-sm,
                                                .account-settings-compact .form-select-sm {
                                                    font-size: 12px;
                                                    padding: 1px 6px;
                                                    min-height: 26px;
                                                    height: auto;
                                                    line-height: 1.3;
                                                }
                                                .account-settings-compact .mb-2 { margin-bottom: 0.25rem !important; }
                                                .account-settings-compact .mb-0 { margin-bottom: 0 !important; }
                                                .account-settings-compact .form-label { font-size: 11px; margin-bottom: 1px; }
                                                .account-settings-compact .g-2 { --bs-gutter-y: 0.25rem; }
                                            `}</style>
                                            <Card className="account-settings-compact" style={{ borderRight: "1px solid #dee2e6", borderLeft: "1px solid #dee2e6", borderBottom: "1px solid #dee2e6", borderTop: "none" }}>
                                                <Card.Body style={{ padding: 6 }}>
                                                    {/* Primary Company Info */}
                                                    <div style={{ fontWeight: 700, marginBottom: 1, fontSize: 12 }}>Primary Company Info</div>

                                                    <Row className="g-2">
                                                        <Col md={3}>

                                                            {/*Company Name*/}
                                                            <Form.Group className="mb-2">
                                                                <Form.Label style={{ marginBottom: 1, fontSize: 11 }}>Company Name</Form.Label>
                                                                <Form.Control
                                                                    size="sm"
                                                                    disabled
                                                                    value={primaryCompany?.companyName ?? ""}
                                                                />
                                                            </Form.Group>

                                                            {/*Company Address*/}
                                                            <Form.Group className="mb-2">
                                                                <Form.Label style={{ marginBottom: 1, fontSize: 11 }}>Company Address</Form.Label>
                                                                <Form.Control
                                                                    size="sm"
                                                                    disabled
                                                                    value={primaryCompany?.companyAddress ?? ""}
                                                                />
                                                            </Form.Group>

                                                            {/*Contact Email Address*/}
                                                            <Form.Group className="mb-2">
                                                                <Form.Label style={{ marginBottom: 1, fontSize: 11 }}>Contact Email Address</Form.Label>
                                                                <Form.Control
                                                                    size="sm"
                                                                    disabled
                                                                    value={primaryCompany?.contactEmailAddress ?? ""}
                                                                />
                                                            </Form.Group>

                                                            {/*Accounting System*/}
                                                            <Form.Group className="mb-0">
                                                                <Form.Label style={{ marginBottom: 1, fontSize: 11 }}>Accounting System</Form.Label>
                                                                <Form.Select
                                                                    size="sm"
                                                                    value={accountDraft.primaryCompanyInfo?.clientAccountingSystemId ?? ""} 
                                                                    onChange={(e) => {
                                                                        const v = e.target.value === "" ? null : Number(e.target.value);
                                                                        setAccountDraft((prev) => ({
                                                                            ...prev,
                                                                            primaryCompanyInfo: { ...prev.primaryCompanyInfo, clientAccountingSystemId: v },
                                                                        }));
                                                                        markAccountDirty();
                                                                    }}
                                                                    style={{
                                                                        ...(isFieldChanged("primaryCompanyInfo", "clientAccountingSystemId") ? changedFieldStyle : {}),
                                                                    }}
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="1">Avatar - Integra</option>
                                                                    <option value="2">Avatar - Petroware</option>
                                                                    <option value="3">Avatar 400</option>
                                                                    <option value="4">CGI - X2R</option>
                                                                    <option value="5">CGI - Petrocomp</option>
                                                                    <option value="6">Enertia</option>
                                                                    <option value="7">IFS - Bolo</option>
                                                                    <option value="8">IFS - Enterprise</option>
                                                                    <option value="9">IFS - Excalibur</option>
                                                                    <option value="10">OGSYS</option>
                                                                    <option value="11">Oracle - JD Edwards</option>
                                                                    <option value="12">Oracle EU</option>
                                                                    <option value="13">Pak Energy</option>
                                                                    <option value="14">Quorum</option>
                                                                    <option value="15">SAP</option>
                                                                    <option value="16">W Energy</option>
                                                                    <option value="17">In_House / Other</option>
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>

                                                        <Col md={3}>
                                                            {/*Member Status*/}
                                                            <Form.Group className="mb-2">
                                                                <Form.Label style={{ marginBottom: 1, fontSize: 11 }}>Member Status</Form.Label>
                                                                <Form.Control
                                                                    size="sm"
                                                                    disabled
                                                                    value={primaryCompany?.memberStatus ?? ""}
                                                                />
                                                            </Form.Group>

                                                            {/*Type*/}
                                                            <Form.Group className="mb-2">
                                                                <Form.Label style={{ marginBottom: 1, fontSize: 11 }}>Type</Form.Label>
                                                                <Form.Control
                                                                    size="sm"
                                                                    disabled
                                                                    value={(accountDraft.primaryCompanyInfo?.type === 1 ? "Operator" : "Owner") ?? ""}
                                                                />
                                                            </Form.Group>

                                                            {/*Type*/}
                                                            {/*<Form.Group className="mb-2">*/}
                                                            {/*    <Form.Label style={{ marginBottom: 1 }}>Type</Form.Label>*/}
                                                            {/*    <Form.Select*/}
                                                            {/*        size="sm"*/}
                                                            {/*        value={accountDraft.primaryCompanyInfo?.type ?? ""}*/}
                                                            {/*        onChange={(e) => {*/}
                                                            {/*            const next = e.target.value === "" ? "" : Number(e.target.value);*/}
                                                            {/*            const current = primaryCompany?.type ?? "";*/}

                                                            {/*            if (Number(current) === 1 && next === 4) {*/}
                                                            {/*                setTypeError("Prohibited Action. Please see developer");*/}
                                                            {/*                return;*/}
                                                            {/*            }*/}

                                                            {/*            setTypeError("");*/}
                                                            {/*            setAccountDraft((prev) => ({*/}
                                                            {/*                ...prev,*/}
                                                            {/*                primaryCompanyInfo: { ...prev.primaryCompanyInfo, type: next },*/}
                                                            {/*            }));*/}
                                                            {/*            markAccountDirty();*/}
                                                            {/*        }}*/}
                                                            {/*        style={{*/}
                                                            {/*            ...(typeError ? changedFieldStyle : {}),*/}
                                                            {/*            ...(isFieldChanged("primaryCompanyInfo", "type") ? changedFieldStyle : {}),*/}
                                                            {/*        }}*/}
                                                            {/*        disabled={true}*/}
                                                            {/*    >*/}
                                                            {/*        <option value={1}>Operator</option>*/}
                                                            {/*        <option value={4}>Owner</option>*/}
                                                            {/*    </Form.Select>*/}
                                                            {/*    {typeError && (*/}
                                                            {/*        <div style={{ marginTop: 4, fontSize: 12, color: "#dc3545", fontWeight: 600 }}>*/}
                                                            {/*            {typeError}*/}
                                                            {/*        </div>*/}
                                                            {/*    )}*/}
                                                            {/*</Form.Group>*/}

                                                            {/*Company #*/}
                                                            <Form.Group className="mb-2">
                                                                <Form.Label style={{ marginBottom: 1, fontSize: 11 }}>Company #</Form.Label>
                                                                <Form.Control
                                                                    size="sm"
                                                                    value={accountDraft.primaryCompanyInfo?.companyNumber ?? ""}
                                                                    onChange={(e) => {
                                                                        const v = e.target.value;
                                                                        setAccountDraft((prev) => ({
                                                                            ...prev,
                                                                            primaryCompanyInfo: { ...prev.primaryCompanyInfo, companyNumber: v },
                                                                        }));
                                                                        markAccountDirty();
                                                                    }}
                                                                    style={{
                                                                        ...(isFieldChanged("primaryCompanyInfo", "companyNumber") ? changedFieldStyle : {}),
                                                                    }}
                                                                    disabled="true"
                                                                />
                                                            </Form.Group>

                                                            {/*Energy Domain*/}
                                                            <Form.Group className="mb-0">
                                                                <Form.Label style={{ marginBottom: 1, fontSize: 11 }}>Energy Domain</Form.Label>
                                                                <Form.Select
                                                                    size="sm"
                                                                    value={accountDraft.primaryCompanyInfo?.energyDomain ?? "N"} 
                                                                    onChange={(e) => {
                                                                        const v = e.target.value;
                                                                        setAccountDraft((prev) => ({
                                                                            ...prev,
                                                                            primaryCompanyInfo: { ...prev.primaryCompanyInfo, energyDomain: v },
                                                                        }));
                                                                        markAccountDirty();
                                                                    }}
                                                                    style={{
                                                                        ...(isFieldChanged("primaryCompanyInfo", "energyDomain") ? changedFieldStyle : {}),
                                                                    }}
                                                                >
                                                                    <option value="N">N</option>
                                                                    <option value="Y">Y</option>
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>

                                                        <Col md={3}>
                                                            {/*Membership Quantity*/}
                                                            <Form.Group className="mb-2">
                                                                <Form.Label style={{ marginBottom: 1, fontSize: 11 }}>Membership Quantity</Form.Label>
                                                                <Form.Control
                                                                    size="sm"
                                                                    disabled
                                                                    value={primaryCompany?.membershipQuantity ?? ""}
                                                                />
                                                            </Form.Group>

                                                            {/*Stripe Customer ID*/}
                                                            <Form.Group className="mb-2">
                                                                <Form.Label style={{ marginBottom: 1, fontSize: 11 }}>Stripe Customer ID</Form.Label>
                                                                <Form.Control
                                                                    size="sm"
                                                                    disabled
                                                                    value={primaryCompany?.stripeCustomerId ?? ""}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>

                                                    {/* Divider */}
                                                    <div style={{ height: 1, background: "#e9ecef", margin: "3px 0" }} />

                                                    {/* Operator Info */}
                                                    <div style={{ fontWeight: 700, marginBottom: 1, fontSize: 12 }}>Operator Info</div>

                                                    {/* Operator Info fields are placed side-by-side rather than stacked to keep total page height small */}
                                                    <Row className="g-2">
                                                        <Col md={3}>
                                                            {/*JIB Format*/}
                                                            <Form.Group className="mb-0">
                                                                <Form.Label style={{ marginBottom: 1, fontSize: 11 }}>JIB Format</Form.Label>
                                                                <Form.Select
                                                                    size="sm"
                                                                    value={accountDraft.operatorInfo?.jibFormatId ?? ""}
                                                                    onChange={(e) => {
                                                                        const v = e.target.value === "" ? null : Number(e.target.value);

                                                                        setAccountDraft((prev) => ({
                                                                            ...prev,
                                                                            operatorInfo: { ...prev.operatorInfo, jibFormatId: v },
                                                                        }));

                                                                        setJibFormatError("Warning: This has an impact to the operator format being loaded");

                                                                        markAccountDirty();
                                                                    }}
                                                                    style={{
                                                                        ...(jibFormatError ? changedFieldStyle : {}),
                                                                        ...(isFieldChanged("operatorInfo", "jibFormatId") ? changedFieldStyle : {}),
                                                                    }}
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="2">EnergyLink XML</option>
                                                                    <option value="3">W Energy</option>
                                                                    <option value="4">Quorum PDS</option>
                                                                    <option value="5">EnergyLink XML v2</option>
                                                                    <option value="6">Enertia2</option>
                                                                    <option value="7">IntegraAvatar</option>
                                                                    <option value="8">SAP - Crescent</option>
                                                                    <option value="9">EnergyLink CSV</option>
                                                                    <option value="10">Bolo</option>
                                                                </Form.Select>
                                                                {jibFormatError && (
                                                                    <div style={{ marginTop: 4, fontSize: 12, color: "#dc3545", fontWeight: 600 }}>
                                                                        {jibFormatError}
                                                                    </div>
                                                                )}
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={3}>
                                                            {/*Revenue Format*/}
                                                            <Form.Group className="mb-0">
                                                                <Form.Label style={{ marginBottom: 1, fontSize: 11 }}>Revenue Format</Form.Label>
                                                                <Form.Select
                                                                    size="sm"
                                                                    value={accountDraft.operatorInfo?.revenueFormatId ?? ""}
                                                                    onChange={(e) => {
                                                                        const v = e.target.value === "" ? null : Number(e.target.value);

                                                                        setAccountDraft((prev) => ({
                                                                            ...prev,
                                                                            operatorInfo: { ...prev.operatorInfo, revenueFormatId: v },
                                                                        }));

                                                                        setRevenueFormatWarning("Warning: This has an impact to the operator format being loaded");

                                                                        markAccountDirty();
                                                                    }}
                                                                    style={{
                                                                        ...(revenueFormatWarning ? changedFieldStyle : {}),
                                                                        ...(isFieldChanged("operatorInfo", "revenueFormatId") ? changedFieldStyle : {}),
                                                                    }}
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="2">EnergyLink XML</option>
                                                                    <option value="3">W Energy</option>
                                                                    <option value="4">Quorum PDS</option>
                                                                    <option value="5">EnergyLink XML v2</option>
                                                                    <option value="6">Enertia2</option>
                                                                    <option value="7">IntegraAvatar</option>
                                                                    <option value="8">SAP - Crescent</option>
                                                                    <option value="9">EnergyLink CSV</option>
                                                                    <option value="10">Bolo</option>
                                                                </Form.Select>
                                                                {revenueFormatWarning && (
                                                                    <div style={{ marginTop: 4, fontSize: 12, color: "#dc3545", fontWeight: 600 }}>
                                                                        {revenueFormatWarning}
                                                                    </div>
                                                                )}
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>

                                                    {/* Divider */}
                                                    <div style={{ height: 1, background: "#e9ecef", margin: "3px 0" }} />

                                                    {/* Non Operator Info */}
                                                    <div style={{ fontWeight: 700, marginBottom: 1, fontSize: 12 }}>Non Operator Info</div>

                                                    <Row className="g-2">
                                                        <Col md={3}>

                                                            {/*JIB Format*/}
                                                            <Form.Group className="mb-2">
                                                                <Form.Label style={{ marginBottom: 1, fontSize: 11 }}>JIB Format</Form.Label>
                                                                <Form.Select size="sm" defaultValue="" disabled>
                                                                    <option value=""></option>
                                                                </Form.Select>
                                                            </Form.Group>

                                                            {/*Revenue Format*/}
                                                            <Form.Group className="mb-0">
                                                                <Form.Label style={{ marginBottom: 1, fontSize: 11 }}>Revenue Format</Form.Label>
                                                                <Form.Select size="sm" defaultValue="" disabled>
                                                                    <option value=""></option>
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>

                                                        {/* DIVIDER */}
                                                        <Col
                                                            md="auto"
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "stretch",
                                                                padding: "0 16px",
                                                            }}
                                                        >
                                                            <div style={{ width: 1, background: "#dee2e6" }} />
                                                        </Col>

                                                        <Col md={3}>

                                                            {/*Document Conversion JIB Format*/}
                                                            <Form.Group className="mb-2">
                                                                <Form.Label style={{ marginBottom: 1, fontSize: 11 }}>Document Conversion JIB Format</Form.Label>
                                                                <Form.Select
                                                                    size="sm"
                                                                    value={docConvJibValue}
                                                                    onChange={(e) => {
                                                                        const val = e.target.value;
                                                                        let networkId = null;
                                                                        let jibOutputId = null;
                                                                        if (val === "N1") { networkId = 1; }
                                                                        else if (val === "N3") { networkId = 3; }
                                                                        else if (val.startsWith("N2-O")) {
                                                                            networkId = 2;
                                                                            const n = Number(val.replace("N2-O", ""));
                                                                            jibOutputId = Number.isFinite(n) ? n : null;
                                                                        }
                                                                        setAccountDraft((prev) => ({
                                                                            ...prev,
                                                                            nonOperatorInfo: {
                                                                                ...prev.nonOperatorInfo,
                                                                                docConversionNetworkTypeId: networkId,
                                                                                docConversionJIBOutputTypeId: jibOutputId,
                                                                            },
                                                                        }));
                                                                        setDocConvFormatWarning("Warning: This has an impact to the non-operator format being loaded");
                                                                        markAccountDirty();
                                                                    }}
                                                                    style={{
                                                                        ...(docConvFormatWarning ? changedFieldStyle : {}),
                                                                        ...(isDocConvChanged() ? changedFieldStyle : {}),
                                                                    }}
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="N2-O3">EL XLS</option>
                                                                    <option value="N2-O1">OGSYS PCX</option>
                                                                    <option value="N1">IMTS</option>
                                                                    <option value="N3">Triage</option>
                                                                </Form.Select>
                                                                {docConvFormatWarning && (
                                                                    <div style={{ marginTop: 4, fontSize: 12, color: "#dc3545", fontWeight: 600 }}>
                                                                        {docConvFormatWarning}
                                                                    </div>
                                                                )}
                                                            </Form.Group>

                                                            {/*Document Conversion Revenue Format*/}
                                                            <Form.Group className="mb-0">
                                                                <Form.Label style={{ marginBottom: 1, fontSize: 11 }}>Document Conversion Revenue Format</Form.Label>
                                                                <Form.Select
                                                                    size="sm"
                                                                    value={docConvRevenueValue}
                                                                    onChange={(e) => {
                                                                        const val = e.target.value;
                                                                        let networkId = null;
                                                                        let revenueOutputId = null;
                                                                        if (val === "N1") { networkId = 1; }
                                                                        else if (val === "N3") { networkId = 3; }
                                                                        else if (val.startsWith("N2-O")) {
                                                                            networkId = 2;
                                                                            const n = Number(val.replace("N2-O", ""));
                                                                            revenueOutputId = Number.isFinite(n) ? n : null;
                                                                        }
                                                                        setAccountDraft((prev) => ({
                                                                            ...prev,
                                                                            nonOperatorInfo: {
                                                                                ...prev.nonOperatorInfo,
                                                                                docConversionNetworkTypeId: networkId,
                                                                                docConversionRevenueOutputTypeId: revenueOutputId,
                                                                            },
                                                                        }));
                                                                        setDocConvFormatWarning("Warning: This has an impact to the non-operator format being loaded");
                                                                        markAccountDirty();
                                                                    }}
                                                                    style={{
                                                                        ...(docConvFormatWarning ? changedFieldStyle : {}),
                                                                        ...(isDocConvChanged() ? changedFieldStyle : {}),
                                                                    }}
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="N2-O3">EL XLS</option>
                                                                    <option value="N2-O2">CDEX</option>
                                                                    <option value="N2-O1">OGSYS PCX</option>
                                                                    <option value="N1">IMTS</option>
                                                                    <option value="N3">Triage</option>
                                                                </Form.Select>
                                                                {docConvFormatWarning && (
                                                                    <div style={{ marginTop: 4, fontSize: 12, color: "#dc3545", fontWeight: 600 }}>
                                                                        {docConvFormatWarning}
                                                                    </div>
                                                                )}
                                                            </Form.Group>
                                                        </Col>

                                                        <Col md={3}>
                                                            {/* spacer to align Billing Rate with Revenue Format row */}
                                                            <Form.Group className="mb-2" aria-hidden="true" style={{ visibility: "hidden" }}>
                                                                <Form.Label style={{ marginBottom: 1, fontSize: 11 }}>&nbsp;</Form.Label>
                                                                <Form.Control size="sm" />
                                                            </Form.Group>

                                                            {/*Document Conversion Billing Rate*/}
                                                            <Form.Group className="mb-0">
                                                                <Form.Label style={{ marginBottom: 1, fontSize: 11 }}>Document Conversion Billing Rate</Form.Label>
                                                                <Form.Control
                                                                    size="sm"
                                                                    type="text"
                                                                    inputMode="decimal"
                                                                    value={(() => {
                                                                        if (billingRateText !== null) return billingRateText;
                                                                        const v = accountDraft?.nonOperatorInfo?.documentConversionBillingRate;
                                                                        return v == null ? "" : Number(v).toFixed(2);
                                                                    })()}
                                                                    onChange={(e) => {
                                                                        const raw = e.target.value;
                                                                        // allow empty, or up to 2-decimal numeric input
                                                                        if (raw !== "" && !/^\d*\.?\d{0,2}$/.test(raw)) return;
                                                                        setBillingRateText(raw);
                                                                        const parsed = raw === "" || raw === "." ? null : Number(raw);
                                                                        setAccountDraft((prev) => ({
                                                                            ...prev,
                                                                            nonOperatorInfo: {
                                                                                ...prev.nonOperatorInfo,
                                                                                documentConversionBillingRate: Number.isFinite(parsed) ? parsed : null,
                                                                            },
                                                                        }));
                                                                        markAccountDirty();
                                                                    }}
                                                                    onBlur={() => setBillingRateText(null)}
                                                                    style={isDocConvChanged() ? changedFieldStyle : {}}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        </div>
                                    </Tab>

                                    {/*** COMPANIES ***/}
                                    <Tab eventKey="companies" title="Companies">
                                        <Col>
                                            <span
                                                style={{
                                                    marginLeft: 12,
                                                    fontSize: 20,
                                                    fontWeight: 500,
                                                    color: "#6c757d"
                                                }}
                                            >
                                                {companyName}&nbsp;
                                            </span>
                                            {(() => {
                                                if (accountId !== null) {
                                                    return (
                                                        <Button
                                                            variant="outline-primary"
                                                            size="sm"
                                                            onClick={() => handleCompanyChange(accountId)}
                                                            style={{
                                                                padding: "1px 6px",
                                                                lineHeight: 1,
                                                                height: 24,
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faSignInAlt} style={{ fontSize: 12 }} />
                                                        </Button>
                                                    );
                                                }
                                            })()}
                                        </Col>
                                        <div
                                            ref={scrollContainerRef}
                                            style={{ maxHeight: (screenHeight - 480).toString() + 'px', overflowY: 'auto' }}
                                        >
                                            <Table striped style={{ borderRight: "1px solid #dee2e6", borderLeft: "1px solid #dee2e6", borderBottom: "1px solid #dee2e6" }}>
                                            
                                            {/*Column Titles*/}
                                                <thead style={{ fontSize: 14 }}>
                                                    <tr>
                                                        <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>Type</th>
                                                        <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>Company Name</th>
                                                        <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>Company #</th>
                                                        <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>Address 1</th>
                                                        <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>City</th>
                                                        <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>State</th>
                                                        <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>Country</th>
                                                        <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>Zip</th>
                                                        <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>Phone</th>
                                                        <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>Email</th>
                                                        <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>Internal Id</th>
                                                    </tr>
                                                </thead>
                                                <tbody style={{ fontSize: 14 }}>
                                                
                                                    {/*Column Values*/}
                                                    {dataStatus === 'loading' ? (
                                                        <LoadingRow colSpan={14} />
                                                    ) : companies.length === 0 ? (
                                                        <tr>
                                                            <td colSpan="14">No companies to display.</td>
                                                        </tr>
                                                    ) : (
                                                        companies.map((company, index) => (
                                                            <tr
                                                                key={company.internalId}
                                                                onMouseEnter={e => Object.assign(e.currentTarget.style, tableRowHover)}
                                                                onMouseLeave={e => Object.assign(e.currentTarget.style, tableRowUnHover)}
                                                            >
                                                                <td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>{getCompanyTypeName(company.companyType)}</td>
                                                                <td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>{company.companyName}</td>
                                                                <td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>
                                                                    {isEditing(company.internalId, "companyCode") ? (
                                                                        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                                                            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                                                                <Form.Control
                                                                                    size="sm"
                                                                                    value={editing.value}
                                                                                    onChange={(e) => {
                                                                                        setEditing((p) => ({ ...p, value: e.target.value }));
                                                                                        clearRowMsg(company.internalId, "companyCode")
                                                                                    }}
                                                                                    style={{ maxWidth: 140, ...(companyCodeWarning ? changedFieldStyle : {}) }}
                                                                                    autoFocus
                                                                                    onKeyDown={(e) => {
                                                                                        if (e.key === "Enter") saveCompanyCode();
                                                                                        if (e.key === "Escape") cancelEdit();
                                                                                    }}
                                                                                />
                                                                                <RowMsg rowId={company.internalId} field="companyCode" />
                                                                                <Button
                                                                                    size="sm"
                                                                                    variant="success"
                                                                                    type="button"
                                                                                    onClick={() => saveCompanyCode()}
                                                                                    style={
                                                                                        hoveredBtn && hoveredBtn?.type === 'search'
                                                                                            ? { ...btnGold, ...btnGoldHover }
                                                                                            : { ...btnGold }
                                                                                    }
                                                                                    onMouseEnter={() => setHoveredBtn({ type: 'search' })}
                                                                                    onMouseLeave={() => setHoveredBtn(null)}
                                                                                >
                                                                                    Save
                                                                                </Button>
                                                                                <Button size="sm" variant="secondary" type="button" onClick={cancelEdit}>
                                                                                    Cancel
                                                                                </Button>
                                                                            </div>
                                                                            {companyCodeWarning && (
                                                                                <div style={{ marginTop: 4, fontSize: 12, color: "#dc3545", fontWeight: 600 }}>
                                                                                    {companyCodeWarning}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    ) : (
                                                                            <>
                                                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                                                    <span style={{ flex: 1 }}>{company.companyCode}</span>
                                                                                    <RowMsg rowId={company.internalId} field="companyCode" />
                                                                                    <Button
                                                                                        variant="link"
                                                                                        size="sm"
                                                                                        type="button"
                                                                                        onClick={() => beginEditCompanyCode(company)}
                                                                                        style={{ marginLeft: "auto", paddingLeft: 6 }}
                                                                                    >
                                                                                        <FontAwesomeIcon icon={faPenToSquare} />
                                                                                    </Button>
                                                                                </div>
                                                                            </>
                                                                    )}
                                                                </td>
                                                                <td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>
                                                                    <div style={{ display: "flex", alignItems: "center" }}>
                                                                        <span style={{ flex: 1 }}>{company.companyAddress1}</span>
                                                                        <RowMsg rowId={company.internalId} field="companyAddress1" />
                                                                        {(() => {
                                                                            if (!isOperatorCompany(company)) {
                                                                                return (
                                                                                    <Button
                                                                                        variant="link"
                                                                                        size="sm"
                                                                                        type="button"
                                                                                        onClick={() => openAddressModal(company)}
                                                                                        style={{ marginLeft: "auto", paddingLeft: 6 }}
                                                                                    >
                                                                                        <FontAwesomeIcon icon={faPenToSquare} />
                                                                                    </Button>
                                                                                );
                                                                            }
                                                                        })()}
                                                                    </div>
                                                                </td>
                                                                <td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>{company.city}</td>
                                                                <td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>{company.state}</td>
                                                                <td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>{company.country}</td>
                                                                <td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>{company.zip}</td>
                                                                <td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>{company.phone}</td>
                                                                <td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>{company.email}</td>
                                                                <td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>{company.internalId}</td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </Table>
                                        </div>
                                        {/*Pagination*/}
                                        {/*{dataStatus === 'ready' && (*/}
                                        {/*    <div className="d-flex justify-content-end">*/}
                                        {/*        <PaginationComponent*/}
                                        {/*            itemsCount={rowCount}*/}
                                        {/*            itemsPerPage={dataCriteria.takeCount}*/}
                                        {/*            currentPage={currentPage}*/}
                                        {/*            setCurrentPage={setCurrentPage}*/}
                                        {/*            pageClickHandler={handlePageClick}*/}
                                        {/*            alwaysShown={true}*/}
                                        {/*            itemStyle={{ ...paginationStyle, color: "black", }}*/}
                                        {/*            activeItemStyle={{ ...activePaginationStyle }}*/}
                                        {/*            itemEvents={{*/}
                                        {/*                onFocus: e => Object.assign(e.target.style, goldInputFocus),*/}
                                        {/*                onBlur: e => Object.assign(e.target.style, { outline: "none", boxShadow: "none", border: "1px solid #ced4da" })*/}
                                        {/*            }}*/}
                                        {/*        />*/}
                                        {/*    </div>*/}
                                        {/*)}*/}
                                    </Tab>

                                    {/*** USERS ***/}
                                    <Tab eventKey="accountusers" title="Account Users">
                                        <Row className="justify-content-between">
                                            <Col>
                                                <span
                                                    style={{
                                                        marginLeft: 12,
                                                        fontSize: 20,
                                                        fontWeight: 500,
                                                        color: "#6c757d"
                                                    }}
                                                >
                                                    {companyName}&nbsp;
                                                </span>
                                                {(() => {
                                                    if (accountId !== null) {
                                                        return (
                                                            <Button
                                                                variant="outline-primary"
                                                                size="sm"
                                                                onClick={() => handleCompanyChange(accountId)}
                                                                style={{
                                                                    padding: "1px 6px",
                                                                    lineHeight: 1,
                                                                    height: 24,
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                }}
                                                            >
                                                                <FontAwesomeIcon icon={faSignInAlt} style={{ fontSize: 12 }} />
                                                            </Button>
                                                        );
                                                    }
                                                })()}
                                            </Col>
                                            {/*Create New User Button*/}
                                            <Col xs="auto" className="mb-3 d-flex align-items-end ms-auto">
                                                <Button
                                                    variant="primary"
                                                    onClick={openCreateUserModal}
                                                    style={
                                                        hoveredBtn && hoveredBtn?.type === 'search'
                                                            ? { ...btnGold, ...btnGoldHover }
                                                            : { ...btnGold }
                                                    }
                                                    onMouseEnter={() => setHoveredBtn({ type: 'search' })}
                                                    onMouseLeave={() => setHoveredBtn(null)}
                                                >
                                                    Create new User
                                                </Button>
                                            </Col>
                                        </Row>
                                        <div
                                            ref={scrollContainerRef}
                                            style={{ maxHeight: (screenHeight - 480).toString() + 'px', overflowY: 'auto' }}
                                        >
                                            <Table striped style={{ borderRight: "1px solid #dee2e6", borderLeft: "1px solid #dee2e6", borderBottom: "1px solid #dee2e6" }}>
                                                {/*Column Titles*/}
                                                <thead style={{ fontSize: 14 }}>
                                                    <tr>
                                                        <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>User Name</th>
                                                        <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>User Email</th>
                                                        <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>Phone</th>
                                                        <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>Last Login</th>
                                                        <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>Status</th>
                                                        <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle, borderRight: "none" }}></th>
                                                    </tr>
                                                </thead>
                                                <tbody style={{ fontSize: 14 }}>
                                                    {/*Column Values*/}
                                                    {dataStatus === 'loading' ? (
                                                        <LoadingRow colSpan={14} />
                                                    ) : users.length === 0 ? (
                                                        <tr>
                                                            <td colSpan="14">No users to display.</td>
                                                        </tr>
                                                    ) : (
                                                        users.map((user, index) => {
                                                            const inactiveCellStyle = !user.isActive ? {
                                                                opacity: 0.5,
                                                                backgroundColor: "#f0f0f0",
                                                                color: "#6c757d",
                                                            } : {};

                                                            return (
                                                                <tr
                                                                    key={user.internalId}
                                                                    onMouseEnter={e => Object.assign(e.currentTarget.style, tableRowHover)}
                                                                    onMouseLeave={e => Object.assign(e.currentTarget.style, tableRowUnHover)}
                                                                >
                                                                    <td style={{ ...inactiveCellStyle, borderRight: "1px solid #dee2e6", paddingRight: 0 }}>{user.userName}</td>
                                                                    <td style={{ ...inactiveCellStyle, borderRight: "1px solid #dee2e6", paddingRight: 0 }}>
                                                                        {isEditing(user.internalId, "userEmail") ? (
                                                                            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                                                                <Form.Control
                                                                                    size="sm"
                                                                                    type="email"
                                                                                    value={editing.value}
                                                                                    onChange={(e) => {
                                                                                        const v = e.target.value;
                                                                                        setEditing((p) => ({ ...p, value: v }));
                                                                                        setUserEmailExistsError("");
                                                                                        clearRowMsg(user.internalId, "userEmail")

                                                                                        if (!v) setUserEmailError("Email is required.");
                                                                                        else if (!emailRegex.test(v)) setUserEmailError("Invalid email address.");
                                                                                        else setUserEmailError("");
                                                                                    }}
                                                                                    style={{ maxWidth: 260 }}
                                                                                    autoFocus
                                                                                    onKeyDown={(e) => {
                                                                                        if (e.key === "Enter") {
                                                                                            if (!userEmailError && !isCheckingUserEmail && !(user.userEmail === editing.value)) saveUserEmailEdit(user);
                                                                                        }
                                                                                        if (e.key === "Escape") cancelEdit();
                                                                                    }}
                                                                                />
                                                                                {userEmailError && (
                                                                                    <div style={{ marginTop: 4, fontSize: 12, color: "#dc3545", fontWeight: 600 }}>
                                                                                        {userEmailError}
                                                                                    </div>
                                                                                )}
                                                                                {userEmailExistsError && (
                                                                                    <div style={{ marginTop: 4, fontSize: 12, color: "#dc3545", fontWeight: 600 }}>
                                                                                        {userEmailExistsError}
                                                                                    </div>
                                                                                )}
                                                                                <RowMsg rowId={user.internalId} field="userEmail" />
                                                                                <Button
                                                                                    size="sm"
                                                                                    type="button"
                                                                                    onClick={() => saveUserEmailEdit(user)}
                                                                                    disabled={!!userEmailError || isCheckingUserEmail || user.userEmail === editing.value}
                                                                                    style={
                                                                                        hoveredBtn && hoveredBtn?.type === 'search'
                                                                                            ? { ...btnGold, ...btnGoldHover }
                                                                                            : { ...btnGold }
                                                                                    }
                                                                                    onMouseEnter={() => setHoveredBtn({ type: 'search' })}
                                                                                    onMouseLeave={() => setHoveredBtn(null)}
                                                                                >
                                                                                    {isCheckingUserEmail ? "Saving..." : "Save"}
                                                                                </Button>
                                                                                <Button
                                                                                    size="sm"
                                                                                    variant="secondary"
                                                                                    type="button"
                                                                                    onClick={cancelEdit}
                                                                                    disabled={isCheckingUserEmail}
                                                                                >
                                                                                    Cancel
                                                                                </Button>
                                                                            </div>
                                                                        ) : (
                                                                            <>
                                                                                <Col>
                                                                                    <div style={{ display: "flex", alignItems: "center" }}>
                                                                                        <span style={{ flex: 1 }}>{user.userEmail}</span>
                                                                                        <RowMsg rowId={user.internalId} field="userEmail" />
                                                                                        <Button
                                                                                            variant="link"
                                                                                            size="sm"
                                                                                            type="button"
                                                                                            onClick={() => beginEditUserEmail(user.internalId, "userEmail", user.userEmail)}
                                                                                            style={{ marginLeft: "auto", paddingLeft: 6 }}
                                                                                            disabled={!user.isActive || isCheckingUserEmail}
                                                                                        >
                                                                                            <FontAwesomeIcon icon={faPenToSquare} />
                                                                                        </Button>
                                                                                    </div>
                                                                                </Col>
                                                                            </>
                                                                        )}
                                                                    </td>
                                                                    <td style={{ ...inactiveCellStyle, borderRight: "1px solid #dee2e6", paddingRight: 0 }}>
                                                                        {user.phone}
                                                                    </td>
                                                                    <td style={{ ...inactiveCellStyle, borderRight: "1px solid #dee2e6", paddingRight: 0 }}>
                                                                        {user.lastLogin
                                                                            ? new Date(user.lastLogin).toLocaleString(undefined, {
                                                                                year: "numeric",
                                                                                month: "2-digit",
                                                                                day: "2-digit",
                                                                                hour: "2-digit",
                                                                                minute: "2-digit",
                                                                                //second: "2-digit", //taking off seconds
                                                                                hour12: true,
                                                                            })
                                                                            : ""}
                                                                    </td>
                                                                    <td style={{ ...inactiveCellStyle, borderRight: "1px solid #dee2e6", paddingRight: 0 }}>
                                                                        {user.isActive ? "Active" : "Inactive"}
                                                                    </td>
                                                                    <td style={{ borderRight: "none", paddingRight: 0, backgroundColor: !user.isActive ? "#f0f0f0" : "" }}>
                                                                        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                                                                            {/* Reset Password */}
                                                                            <Button
                                                                                size="sm"
                                                                                type="button"
                                                                                disabled={!user.isActive}
                                                                                onClick={() => openPasswordResetModal(user)}
                                                                            >
                                                                                <FontAwesomeIcon icon={faArrowRotateLeft} /> Reset Password
                                                                            </Button>

                                                                            {/* Delete User */}
                                                                            {user.isActive && (
                                                                                <Button
                                                                                    size="sm"
                                                                                    type="button"
                                                                                    disabled={!user.isActive}
                                                                                    onClick={() => openDeleteUserModal(user)}
                                                                                    onMouseEnter={e => {
                                                                                        if (user.isActive) Object.assign(e.currentTarget.style, { backgroundColor: "darkRed", borderColor: "darkRed" });
                                                                                    }}
                                                                                    onMouseLeave={e => {
                                                                                        if (user.isActive) Object.assign(e.currentTarget.style, { backgroundColor: "#dc3545", borderColor: "#dc3545" });
                                                                                    }}
                                                                                    style={{ backgroundColor: "#dc3545", borderColor: "#dc3545", marginLeft: 16 }}
                                                                                >
                                                                                    <FontAwesomeIcon icon={faDeleteLeft} /> De-activate User
                                                                                </Button>
                                                                            )}

                                                                            {/* Re-activate User */}
                                                                            {!user.isActive && (
                                                                                <Button
                                                                                    size="sm"
                                                                                    type="button"
                                                                                    disabled={user.isActive}
                                                                                    onClick={() => openActivateUserModal(user)}
                                                                                    onMouseEnter={e => {
                                                                                        if (!user.isActive) Object.assign(e.currentTarget.style, { backgroundColor: "darkGreen", borderColor: "darkGreen" });
                                                                                    }}
                                                                                    onMouseLeave={e => {
                                                                                        if (!user.isActive) Object.assign(e.currentTarget.style, { backgroundColor: "green", borderColor: "green" });
                                                                                    }}
                                                                                    style={{
                                                                                        backgroundColor: "green",
                                                                                        borderColor: "green",
                                                                                        marginLeft: 16
                                                                                    }}
                                                                                >
                                                                                    <FontAwesomeIcon icon={faUserCheck} /> Re-activate User
                                                                                </Button>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    )}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Tab>

                                    {/* Merge */}
                                    <Tab eventKey="merge" title="Merge" disabled={!isMergeTabEnabled}>
                                        <div
                                            style={{
                                                // No forced height — let the tab size to its content. The density
                                                // reductions below (smaller table rows, tighter card padding) keep
                                                // the natural content height small enough to fit a normal viewport
                                                // without page scrolling, and there's no awkward empty space when
                                                // the content is shorter than the viewport.
                                                padding: "4px",
                                                overflowX: "hidden",
                                            }}
                                        >
                                            <Row className="mx-0">

                                                {/* MERGE TO */}
                                                <Col md={5}>
                                                    <Card style={{ border: "1px solid #dee2e6" }}>
                                                        <Card.Header style={{ fontWeight: 600, fontSize: 13, background: "#f8f9fa", padding: "6px 12px" }}>
                                                            Company to Merge
                                                        </Card.Header>
                                                        <Card.Body style={{ padding: 10 }}>

                                                            {/* Search */}
                                                            <div style={{ position: "relative" }}>
                                                                <Row className="g-2 mb-2">
                                                                    <Col md={5}>
                                                                        <Form.Group>
                                                                            <Form.Label style={{ fontSize: 12, marginBottom: 2 }}>Company Name</Form.Label>
                                                                            <Form.Control
                                                                                size="sm"
                                                                                value={mergeToSearch.companyName}
                                                                                onChange={(e) =>
                                                                                    setMergeToSearch((p) => ({ ...p, companyName: e.target.value }))
                                                                                }
                                                                                onKeyDown={(e) => { if (e.key === "Enter") searchMergeTo(); }}
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                    <Col md={5}>
                                                                        <Form.Group>
                                                                            <Form.Label style={{ fontSize: 12, marginBottom: 2 }}>Enter Internal ID</Form.Label>
                                                                            <Form.Control
                                                                                size="sm"
                                                                                value={mergeToSearch.internalId}
                                                                                onChange={(e) =>
                                                                                    setMergeToSearch((p) => ({ ...p, internalId: e.target.value }))
                                                                                }
                                                                                onKeyDown={(e) => { if (e.key === "Enter") searchMergeTo(); }}
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                    <Col md={2} className="d-flex align-items-end">
                                                                        <Button
                                                                            size="sm"
                                                                            onClick={searchMergeTo}
                                                                            disabled={isMergeSearching}
                                                                            style={{ ...btnGold, width: "100%" }}
                                                                        >
                                                                            {isMergeSearching ? <Spinner animation="border" size="sm" /> : <FontAwesomeIcon icon={faMagnifyingGlass} />}
                                                                        </Button>
                                                                    </Col>
                                                                </Row>

                                                                {/* search results dropdown — absolute so it overlays the detail table below instead of pushing it down */}
                                                                {mergeToResults.length > 0 && (
                                                                    <div
                                                                        style={{
                                                                            position: "absolute",
                                                                            top: "100%",
                                                                            left: 0,
                                                                            right: 0,
                                                                            zIndex: 20,
                                                                            background: "#fff",
                                                                            boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                                                                            border: "1px solid #dee2e6",
                                                                            borderRadius: 4,
                                                                            maxHeight: 200,
                                                                            overflowY: "auto",
                                                                            fontSize: 11,
                                                                        }}
                                                                    >
                                                                    {mergeToResults.map((r) => {
                                                                        const eligible = r.isMergeable !== false;
                                                                        return (
                                                                            <div
                                                                                key={r.id}
                                                                                onClick={eligible ? () => selectMergeTo(r) : undefined}
                                                                                style={{
                                                                                    padding: "4px 8px",
                                                                                    cursor: eligible ? "pointer" : "not-allowed",
                                                                                    borderBottom: "1px solid #f0f0f0",
                                                                                    backgroundColor: eligible ? "" : "#f5f5f5",
                                                                                    opacity: eligible ? 1 : 0.75,
                                                                                }}
                                                                                onMouseEnter={e => { if (eligible) e.currentTarget.style.backgroundColor = "#f8f9fa"; }}
                                                                                onMouseLeave={e => { e.currentTarget.style.backgroundColor = eligible ? "" : "#f5f5f5"; }}
                                                                            >
                                                                                <div style={{ fontWeight: 500, color: eligible ? "inherit" : "#6c757d" }}>
                                                                                    {r.companyName}
                                                                                </div>
                                                                                <div style={{ color: "#6c757d", fontSize: 10 }}>
                                                                                    ID: {r.id} &nbsp; {r.companyTypeName}
                                                                                </div>
                                                                                <div style={{ color: "#6c757d", fontSize: 10 }}>
                                                                                    {r.address1}{r.city ? `, ${r.city}` : ""}{r.state ? `, ${r.state}` : ""}
                                                                                </div>
                                                                                {!eligible && (
                                                                                    <div style={{ color: "#b02a37", fontSize: 10, fontStyle: "italic", marginTop: 2 }}>
                                                                                        Cannot merge: {r.ineligibleReason}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                                )}
                                                            </div>

                                                            {/* Details */}
                                                            <MergeDetailTable details={mergeToDetails} label="Selected company" />
                                                        </Card.Body>
                                                    </Card>
                                                </Col>

                                                {/* ARROW */}
                                                <Col md={2} className="d-flex align-items-center justify-content-center">
                                                    <div style={{ textAlign: "center" }}>
                                                        <div style={{
                                                            fontSize: 140,
                                                            fontWeight: 900,
                                                            lineHeight: 1,
                                                            color: "#28a745",
                                                            WebkitTextStroke: "4px #28a745",
                                                            textShadow: "0 4px 10px rgba(40,167,69,0.4)",
                                                        }}>&#10132;</div>
                                                    </div>
                                                </Col>

                                                {/* MERGE TO */}
                                                <Col md={5}>
                                                    <Card style={{ border: "1px solid #dee2e6" }}>
                                                        <Card.Header style={{ fontWeight: 600, fontSize: 13, background: "#f8f9fa", padding: "6px 12px" }}>
                                                            Current Account
                                                        </Card.Header>
                                                        <Card.Body style={{ padding: 10 }}>

                                                            {/* PRIMARY COMPANY INFO */}
                                                            <Row className="g-2 mb-3">
                                                                <Col md={6}>
                                                                    <Form.Group>
                                                                        <Form.Label style={{ fontSize: 12, marginBottom: 2 }}>Company Name</Form.Label>
                                                                        <Form.Control
                                                                            size="sm"
                                                                            disabled
                                                                            value={primaryCompany?.companyName ?? ""}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <Form.Group>
                                                                        <Form.Label style={{ fontSize: 12, marginBottom: 2 }}>Account ID</Form.Label>
                                                                        <Form.Control
                                                                            size="sm"
                                                                            disabled
                                                                            value={accountId ?? ""}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                            </Row>

                                                            {/* Details */}
                                                            <MergeDetailTable details={buildMergeFromDetails()} label="Selected company" />
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            </Row>

                                            {/* CONFIRM — mt-2 keeps the merge button visible without taking extra vertical space */}
                                            <Row className="mt-2">
                                                <Col className="d-flex justify-content-center">
                                                    <Button
                                                        onClick={handleMergeConfirm}
                                                        disabled={!mergeToDetails}
                                                        style={
                                                            hoveredBtn?.type === "mergeConfirm"
                                                                ? { ...btnGold, ...btnGoldHover, minWidth: 140 }
                                                                : { ...btnGold, minWidth: 140 }
                                                        }
                                                        onMouseEnter={() => setHoveredBtn({ type: "mergeConfirm" })}
                                                        onMouseLeave={() => setHoveredBtn(null)}
                                                    >
                                                        Merge
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Tab>
                                </Tabs>
                            </Row>
                        </Container>
                    </div>
            )}

            {/*Edit company address modal*/}
            <Modal
                show={showCompanyAddressModal}
                onHide={closeAddressModal}
                centered
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Edit Company Address</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {addressCompanyName && (
                        <div style={{ marginBottom: 10, color: "#6c757d", fontWeight: 600 }}>
                            {addressCompanyName}
                        </div>
                    )}
                    {isAddressDirty() && (
                        <div style={{ marginBottom: 8, fontSize: 12, color: "#dc3545", fontWeight: 600 }}>
                            You have unsaved changes.
                        </div>
                    )}
                    {companyAddressWarning && (
                        <div style={{ marginBottom: 8, fontSize: 12, color: "#dc3545", fontWeight: 600 }}>
                            {companyAddressWarning}
                        </div>
                    )}

                    <Row className="g-2">
                        <Col md={12}>
                            <Form.Group className="mb-2">
                                <Form.Label style={{ marginBottom: 1 }}>Address 1</Form.Label>
                                <Form.Control
                                    size="sm"
                                    value={addressDraft.companyAddress1}
                                    onChange={(e) =>
                                        setAddressDraft((p) => ({ ...p, companyAddress1: e.target.value }))
                                    }
                                    style={{
                                        ...(isAddressFieldChanged("companyAddress1") ? addressChangedFieldStyle : {}),
                                    }}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={12}>
                            <Form.Group className="mb-2">
                                <Form.Label style={{ marginBottom: 1 }}>Address 2</Form.Label>
                                <Form.Control
                                    size="sm"
                                    value={addressDraft.companyAddress2}
                                    onChange={(e) =>
                                        setAddressDraft((p) => ({ ...p, companyAddress2: e.target.value }))
                                    }
                                    style={{
                                        ...(isAddressFieldChanged("companyAddress2") ? addressChangedFieldStyle : {}),
                                    }}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={12}>
                            <Form.Group className="mb-2">
                                <Form.Label style={{ marginBottom: 1 }}>Address 3</Form.Label>
                                <Form.Control
                                    size="sm"
                                    value={addressDraft.companyAddress3}
                                    onChange={(e) =>
                                        setAddressDraft((p) => ({ ...p, companyAddress3: e.target.value }))
                                    }
                                    style={{
                                        ...(isAddressFieldChanged("companyAddress3") ? addressChangedFieldStyle : {}),
                                    }}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label style={{ marginBottom: 1 }}>City</Form.Label>
                                <Form.Control
                                    size="sm"
                                    value={addressDraft.city}
                                    onChange={(e) =>
                                        setAddressDraft((p) => ({ ...p, city: e.target.value }))
                                    }
                                    style={{
                                        ...(isAddressFieldChanged("city") ? addressChangedFieldStyle : {}),
                                    }}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label style={{ marginBottom: 1 }}>State</Form.Label>
                                <Form.Control
                                    size="sm"
                                    value={addressDraft.state}
                                    onChange={(e) =>
                                        setAddressDraft((p) => ({ ...p, state: e.target.value }))
                                    }
                                    style={{
                                        ...(isAddressFieldChanged("state") ? addressChangedFieldStyle : {}),
                                    }}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label style={{ marginBottom: 1 }}>Zip</Form.Label>
                                <Form.Control
                                    size="sm"
                                    value={addressDraft.zip}
                                    onChange={(e) =>
                                        setAddressDraft((p) => ({ ...p, zip: e.target.value }))
                                    }
                                    style={{
                                        ...(isAddressFieldChanged("zip") ? addressChangedFieldStyle : {}),
                                    }}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label style={{ marginBottom: 1 }}>Country</Form.Label>
                                <Form.Control
                                    size="sm"
                                    value={addressDraft.country}
                                    onChange={(e) =>
                                        setAddressDraft((p) => ({ ...p, country: e.target.value }))
                                    }
                                    style={{
                                        ...(isAddressFieldChanged("country") ? addressChangedFieldStyle : {}),
                                    }}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label style={{ marginBottom: 1 }}>Phone</Form.Label>
                                <Form.Control
                                    size="sm"
                                    value={addressDraft.phone}
                                    onChange={(e) =>
                                        setAddressDraft((p) => ({ ...p, phone: e.target.value }))
                                    }
                                    style={{
                                        ...(isAddressFieldChanged("phone") ? addressChangedFieldStyle : {}),
                                    }}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label style={{ marginBottom: 1 }}>Fax</Form.Label>
                                <Form.Control
                                    size="sm"
                                    value={addressDraft.fax}
                                    onChange={(e) =>
                                        setAddressDraft((p) => ({ ...p, fax: e.target.value }))
                                    }
                                    style={{
                                        ...(isAddressFieldChanged("fax") ? addressChangedFieldStyle : {}),
                                    }}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={12}>
                            <Form.Group className="mb-2">
                                <Form.Label style={{ marginBottom: 1 }}>Email</Form.Label>
                                <Form.Control
                                    size="sm"
                                    type="email"
                                    value={addressDraft.email}
                                    onChange={(e) => {
                                        const v = e.target.value;

                                        setAddressDraft((p) => ({ ...p, email: v }));

                                        if (!v.trim()) {
                                            setCompanyEmailError("Email is required.")
                                        }
                                        else if (v && !emailRegex.test(v)) {
                                            setCompanyEmailError("Invalid email address.");
                                        } else {
                                            setCompanyEmailError("");
                                        }
                                    }}
                                    style={{
                                        ...(companyEmailError ? addressChangedFieldStyle : {}),
                                        ...(isAddressFieldChanged("email") ? addressChangedFieldStyle : {}),
                                    }}
                                />
                                {companyEmailError && (
                                    <div style={{ marginTop: 4, fontSize: 12, color: "#dc3545", fontWeight: 600 }}>
                                        {companyEmailError}
                                    </div>
                                )}
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" type="button" onClick={closeAddressModal}>
                        Cancel
                    </Button>
                    <Button
                        type="button"
                        onClick={saveCompanyAddress}
                        disabled={!!companyEmailError}
                        style={
                            hoveredBtn && hoveredBtn?.type === 'search'
                                ? { ...btnGold, ...btnGoldHover }
                                : { ...btnGold }
                        }
                        onMouseEnter={() => setHoveredBtn({ type: 'search' })}
                        onMouseLeave={() => setHoveredBtn(null)}
                    >
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>

            {/*Confirm Password Reset Modal*/}
            <Modal
                show={showPasswordResetModal}
                onHide={closePasswordResetModal}
                centered
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Reset Password</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Row className="g-2">
                        <Col style={{ display: "flex", justifyContent: "center", textAlign: "center", fontWeight: 700 }}>
                            <span>
                                Send password reset to
                            </span>
                        </Col>
                    </Row>
                    <Row className="g-2">
                        <Col style={{ display: "flex", justifyContent: "center", textAlign: "center"}}>
                            <span style={{ }}>
                                {passwordResetUser?.userEmail || ""}
                            </span>
                        </Col>
                    </Row>
                    {passwordResetMessage && (
                        <Row className="g-2 mt-1">
                            <Col style={{ display: "flex", justifyContent: "center", textAlign: "center" }}>
                                <span style={{
                                    fontSize: 13,
                                    fontWeight: 600,
                                    color: passwordResetMessage.type === "success" ? "green" : "#dc3545"
                                }}>
                                    {passwordResetMessage.text}
                                </span>
                            </Col>
                        </Row>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Container>
                        <Row>
                            <Col style={{ display: "flex", justifyContent: "left" }}>
                                <Button variant="secondary" type="button" onClick={closePasswordResetModal}>
                                    Cancel
                                </Button>
                            </Col>
                            <Col style={{ display: "flex", justifyContent: "right" }}>
                                {!passwordResetMessage ? (
                                    <Button
                                        type="button"
                                        onClick={resetUserPassword}
                                        style={
                                            hoveredBtn?.type === 'search'
                                                ? { ...btnGold, ...btnGoldHover }
                                                : { ...btnGold }
                                        }
                                        onMouseEnter={() => setHoveredBtn({ type: 'search' })}
                                        onMouseLeave={() => setHoveredBtn(null)}
                                    >
                                        Confirm
                                    </Button>
                                ) : (
                                    <Button variant="secondary" type="button" onClick={closePasswordResetModal}>
                                        Close
                                    </Button>
                                )}
                            </Col>
                        </Row>
                    </Container>
                </Modal.Footer>
            </Modal>

            {/*Confirm Delete User Modal*/}
            <Modal
                show={showDeleteUserModal}
                onHide={closeDeleteUserModal}
                centered
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete User</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Row className="g-2">
                        <Col style={{ display: "flex", justifyContent: "center", textAlign: "center" }}>
                            <span style={{ fontWeight: 700 }}>
                                Delete User:
                            </span>
                        </Col>
                    </Row>
                    <Row className="g-2">
                        <Col style={{ display: "flex", justifyContent: "center", textAlign: "center" }}>
                            <span>
                                {deleteUserUser?.userName || ""}
                            </span>
                        </Col>
                    </Row>
                    <Row className="g-2">
                        <Col style={{ display: "flex", justifyContent: "center", textAlign: "center" }}>
                            <span>
                                {deleteUserUser?.userEmail || ""}
                            </span>
                        </Col>
                    </Row>
                </Modal.Body>

                <Modal.Footer>
                    <Container>
                        <Row>
                            <Col style={{ display: "flex", justifyContent: "left" }}>
                                <Button variant="secondary" type="button" onClick={closeDeleteUserModal}>
                                    Cancel
                                </Button>
                            </Col>
                            <Col style={{ display: "flex", justifyContent: "right" }}>
                                <Button
                                    type="button"
                                    onClick={deleteUser}
                                    style={
                                        hoveredBtn && hoveredBtn?.type === 'search'
                                            ? { ...btnGold, ...btnGoldHover }
                                            : { ...btnGold }
                                    }
                                    onMouseEnter={() => setHoveredBtn({ type: 'search' })}
                                    onMouseLeave={() => setHoveredBtn(null)}
                                >
                                    Confirm
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Footer>
            </Modal>

            {/*Confirm Activate User Modal*/}
            <Modal
                show={showActivateUserModal}
                onHide={closeActivateUserModal}
                centered
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Re-activate User</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Row className="g-2">
                        <Col style={{ display: "flex", justifyContent: "center", textAlign: "center" }}>
                            <span style={{ fontWeight: 700 }}>
                                Re-activate User:
                            </span>
                        </Col>
                    </Row>
                    <Row className="g-2">
                        <Col style={{ display: "flex", justifyContent: "center", textAlign: "center" }}>
                            <span>
                                {activateUserUser?.userName || ""}
                            </span>
                        </Col>
                    </Row>
                    <Row className="g-2">
                        <Col style={{ display: "flex", justifyContent: "center", textAlign: "center" }}>
                            <span>
                                {activateUserUser?.userEmail || ""}
                            </span>
                        </Col>
                    </Row>
                </Modal.Body>

                <Modal.Footer>
                    <Container>
                        <Row>
                            <Col style={{ display: "flex", justifyContent: "left" }}>
                                <Button variant="secondary" type="button" onClick={closeActivateUserModal}>
                                    Cancel
                                </Button>
                            </Col>
                            <Col style={{ display: "flex", justifyContent: "right" }}>
                                <Button
                                    type="button"
                                    onClick={reActivateUser}
                                    style={
                                        hoveredBtn && hoveredBtn?.type === 'search'
                                            ? { ...btnGold, ...btnGoldHover }
                                            : { ...btnGold }
                                    }
                                    onMouseEnter={() => setHoveredBtn({ type: 'search' })}
                                    onMouseLeave={() => setHoveredBtn(null)}
                                >
                                    Confirm
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Footer>
            </Modal>

            {/*Create New User Modal*/}
            <Modal
                show={showCreateUserModal}
                onHide={closeCreateUserModal}
                centered
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Create New User</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {createUserGeneralError && (   
                        <div style={{ marginBottom: 8, fontSize: 12, color: "#dc3545", fontWeight: 600 }}>
                            {createUserGeneralError}
                        </div>
                    )}
                    <Row className="g-2">
                        {/* Email */}
                        <Col md={12}>
                            <Form.Group className="mb-2">
                                <Form.Label style={{ marginBottom: 1 }}>
                                    Email <span style={{ color: "#dc3545" }}>*</span>
                                </Form.Label>
                                <Form.Control
                                    size="sm"
                                    type="email"
                                    placeholder="user@example.com"
                                    value={createUserDraft.email}
                                    onChange={(e) => {
                                        const v = e.target.value;
                                        setCreateUserDraft((p) => ({ ...p, email: v }));
                                        if (!v.trim()) setCreateUserEmailError("Email is required.");
                                        else if (!emailRegex.test(v)) setCreateUserEmailError("Invalid email address.");
                                        else setCreateUserEmailError("");
                                    }}
                                    style={{
                                        ...(createUserEmailError ? addressChangedFieldStyle : {}),
                                    }}
                                />
                                {createUserEmailError && (
                                    <div style={{ marginTop: 4, fontSize: 12, color: "#dc3545", fontWeight: 600 }}>
                                        {createUserEmailError}
                                    </div>
                                )}
                            </Form.Group>
                        </Col>

                        {/* First Name */}
                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label style={{ marginBottom: 1 }}>
                                    First Name <span style={{ color: "#dc3545" }}>*</span>
                                </Form.Label>
                                <Form.Control
                                    size="sm"
                                    placeholder="First name"
                                    value={createUserDraft.firstName}
                                    onChange={(e) =>
                                        setCreateUserDraft((p) => ({ ...p, firstName: e.target.value }))
                                    }
                                />
                            </Form.Group>
                        </Col>

                        {/* Last Name */}
                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label style={{ marginBottom: 1 }}>
                                    Last Name <span style={{ color: "#dc3545" }}>*</span>
                                </Form.Label>
                                <Form.Control
                                    size="sm"
                                    placeholder="Last name"
                                    value={createUserDraft.lastName}
                                    onChange={(e) =>
                                        setCreateUserDraft((p) => ({ ...p, lastName: e.target.value }))
                                    }
                                />
                            </Form.Group>
                        </Col>

                        {/* Address 1 */}
                        <Col md={12}>
                            <Form.Group className="mb-2">
                                <Form.Label style={{ marginBottom: 1 }}>Address</Form.Label>
                                <Form.Control
                                    size="sm"
                                    value={createUserDraft.companyAddress1}
                                    onChange={(e) =>
                                        setCreateUserDraft((p) => ({ ...p, companyAddress1: e.target.value }))
                                    }
                                />
                            </Form.Group>
                        </Col>

                        {/* Address 2 */}
                        <Col md={12}>
                            <Form.Group className="mb-2">
                                <Form.Label style={{ marginBottom: 1 }}>Address 2</Form.Label>
                                <Form.Control
                                    size="sm"
                                    value={createUserDraft.companyAddress2}
                                    onChange={(e) =>
                                        setCreateUserDraft((p) => ({ ...p, companyAddress2: e.target.value }))
                                    }
                                />
                            </Form.Group>
                        </Col>

                        {/* Address 3 */}
                        <Col md={12}>
                            <Form.Group className="mb-2">
                                <Form.Label style={{ marginBottom: 1 }}>Address 3</Form.Label>
                                <Form.Control
                                    size="sm"
                                    value={createUserDraft.companyAddress3}
                                    onChange={(e) =>
                                        setCreateUserDraft((p) => ({ ...p, companyAddress3: e.target.value }))
                                    }
                                />
                            </Form.Group>
                        </Col>

                        {/* City */}
                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label style={{ marginBottom: 1 }}>City</Form.Label>
                                <Form.Control
                                    size="sm"
                                    value={createUserDraft.city}
                                    onChange={(e) =>
                                        setCreateUserDraft((p) => ({ ...p, city: e.target.value }))
                                    }
                                />
                            </Form.Group>
                        </Col>

                        {/* State */}
                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label style={{ marginBottom: 1 }}>State</Form.Label>
                                <Form.Control
                                    size="sm"
                                    value={createUserDraft.state}
                                    onChange={(e) =>
                                        setCreateUserDraft((p) => ({ ...p, state: e.target.value }))
                                    }
                                />
                            </Form.Group>
                        </Col>

                        {/* Zip */}
                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label style={{ marginBottom: 1 }}>Zip</Form.Label>
                                <Form.Control
                                    size="sm"
                                    value={createUserDraft.zip}
                                    onChange={(e) =>
                                        setCreateUserDraft((p) => ({ ...p, zip: e.target.value }))
                                    }
                                />
                            </Form.Group>
                        </Col>

                        {/* Country */}
                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label style={{ marginBottom: 1 }}>Country</Form.Label>
                                <Form.Control
                                    size="sm"
                                    value={createUserDraft.country}
                                    onChange={(e) =>
                                        setCreateUserDraft((p) => ({ ...p, country: e.target.value }))
                                    }
                                />
                            </Form.Group>
                        </Col>

                        {/* Phone */}
                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label style={{ marginBottom: 1 }}>Phone</Form.Label>
                                <Form.Control
                                    size="sm"
                                    value={createUserDraft.phone}
                                    onChange={(e) =>
                                        setCreateUserDraft((p) => ({ ...p, phone: e.target.value }))
                                    }
                                />
                            </Form.Group>
                        </Col>

                        {/* Fax */}
                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label style={{ marginBottom: 1 }}>Fax</Form.Label>
                                <Form.Control
                                    size="sm"
                                    value={createUserDraft.fax}
                                    onChange={(e) =>
                                        setCreateUserDraft((p) => ({ ...p, fax: e.target.value }))
                                    }
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>

                <Modal.Footer>
                    <Container>
                        <Row>
                            <Col style={{ display: "flex", justifyContent: "left" }}>
                                <Button variant="secondary" type="button" onClick={closeCreateUserModal}>
                                    Cancel
                                </Button>
                            </Col>
                            <Col style={{ display: "flex", justifyContent: "right" }}>
                                <Button
                                    type="button"
                                    onClick={saveNewUser}
                                    disabled={
                                        isCreatingUser ||
                                        !!createUserEmailError ||
                                        !createUserDraft.email.trim() ||
                                        !createUserDraft.firstName.trim() ||
                                        !createUserDraft.lastName.trim()
                                    }
                                    style={
                                        hoveredBtn?.type === 'search'
                                            ? { ...btnGold, ...btnGoldHover }
                                            : { ...btnGold }
                                    }
                                    onMouseEnter={() => setHoveredBtn({ type: 'search' })}
                                    onMouseLeave={() => setHoveredBtn(null)}
                                >
                                    {isCreatingUser ? "Creating..." : "Create User"}
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Footer>
            </Modal>

            {/*Merge Confirm Modal*/}
            <Modal
                show={showMergeConfirmModal}
                onHide={() => {
                    closeMergeConfirmModal()
                }}
                centered
                backdrop="static"
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Merge</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {mergeResult && (
                        <div style={{ marginBottom: 16 }}>
                            {/* Company update result */}
                            <div style={{
                                padding: "8px 12px",
                                borderRadius: 4,
                                marginBottom: 6,
                                fontSize: 13,
                                fontWeight: 600,
                                color: mergeResult.companyUpdateSuccess ? "green" : "#dc3545",
                                background: mergeResult.companyUpdateSuccess
                                    ? "rgba(0,128,0,0.07)" : "rgba(220,53,69,0.07)",
                                border: `1px solid ${mergeResult.companyUpdateSuccess
                                    ? "rgba(0,128,0,0.2)" : "rgba(220,53,69,0.2)"}`,
                            }}>
                                {mergeResult.companyUpdateSuccess
                                    ? "Company record updated successfully."
                                    : `Company update failed: ${mergeResult.companyUpdateError}`}
                            </div>
                            {/* Account senders result */}
                            <div style={{
                                padding: "8px 12px",
                                borderRadius: 4,
                                fontSize: 13,
                                fontWeight: 600,
                                color: mergeResult.accountSendersSuccess ? "green" : "#dc3545",
                                background: mergeResult.accountSendersSuccess ? "rgba(0,128,0,0.07)" : "rgba(220,53,69,0.07)",
                                border: `1px solid ${mergeResult.accountSendersSuccess ? "rgba(0,128,0,0.2)" : "rgba(220,53,69,0.2)"}`,
                            }}>
                                {mergeResult.accountSendersSuccess
                                    ? `Account senders updated. ${mergeResult.accountSendersAdded} new sender(s) added.`
                                    : `Account senders failed: ${mergeResult.accountSendersError}`}
                            </div>

                            {/*
                                Stripe sync banners.
                                Three visual states map to the StripeQuantitySyncResultDTO:
                                  - success && !skipped → green ("synced to N")
                                  - success && skipped → neutral gray ("no Stripe sub, nothing to sync")
                                  - !success           → red   ("Stripe call failed: ...")
                                Source banner only renders when the sync was actually attempted —
                                we hide it for orphans / source==target since there's nothing useful to say.
                            */}
                            {mergeResult.targetStripeSync && (
                                <div style={{
                                    padding: "8px 12px",
                                    borderRadius: 4,
                                    marginTop: 6,
                                    fontSize: 13,
                                    fontWeight: 600,
                                    color: !mergeResult.targetStripeSync.success
                                        ? "#dc3545"
                                        : mergeResult.targetStripeSync.skipped ? "#6c757d" : "green",
                                    background: !mergeResult.targetStripeSync.success
                                        ? "rgba(220,53,69,0.07)"
                                        : mergeResult.targetStripeSync.skipped ? "rgba(108,117,125,0.07)" : "rgba(0,128,0,0.07)",
                                    border: `1px solid ${!mergeResult.targetStripeSync.success
                                        ? "rgba(220,53,69,0.2)"
                                        : mergeResult.targetStripeSync.skipped ? "rgba(108,117,125,0.2)" : "rgba(0,128,0,0.2)"}`,
                                }}>
                                    {!mergeResult.targetStripeSync.success
                                        ? `Target Stripe sync failed: ${mergeResult.targetStripeSync.message}`
                                        : mergeResult.targetStripeSync.skipped
                                            ? `Target Stripe sync skipped: ${mergeResult.targetStripeSync.message}`
                                            : `Target Stripe sync: ${mergeResult.targetStripeSync.message}`}
                                </div>
                            )}
                            {mergeResult.sourceStripeSync && mergeResult.sourceStripeSync.attempted && (
                                <div style={{
                                    padding: "8px 12px",
                                    borderRadius: 4,
                                    marginTop: 6,
                                    fontSize: 13,
                                    fontWeight: 600,
                                    color: !mergeResult.sourceStripeSync.success
                                        ? "#dc3545"
                                        : mergeResult.sourceStripeSync.skipped ? "#6c757d" : "green",
                                    background: !mergeResult.sourceStripeSync.success
                                        ? "rgba(220,53,69,0.07)"
                                        : mergeResult.sourceStripeSync.skipped ? "rgba(108,117,125,0.07)" : "rgba(0,128,0,0.07)",
                                    border: `1px solid ${!mergeResult.sourceStripeSync.success
                                        ? "rgba(220,53,69,0.2)"
                                        : mergeResult.sourceStripeSync.skipped ? "rgba(108,117,125,0.2)" : "rgba(0,128,0,0.2)"}`,
                                }}>
                                    {!mergeResult.sourceStripeSync.success
                                        ? `Source Stripe sync failed: ${mergeResult.sourceStripeSync.message}`
                                        : mergeResult.sourceStripeSync.skipped
                                            ? `Source Stripe sync skipped: ${mergeResult.sourceStripeSync.message}`
                                            : `Source Stripe sync: ${mergeResult.sourceStripeSync.message}`}
                                </div>
                            )}
                        </div>
                    )}
                    <Row className="g-3 align-items-center">
                        <Col md={5}>
                            <div
                                style={{
                                    border: "1px solid #dee2e6",
                                    borderRadius: 6,
                                    padding: "10px 14px",
                                    fontSize: 13,
                                }}
                            >
                                <div style={{ fontWeight: 600, marginBottom: 2 }}>{mergeToDetails?.companyName}</div>
                                <div style={{ fontSize: 11, color: "#6c757d", marginBottom: 6 }}>
                                    ID: {mergeToDetails?.internalId} &nbsp;&nbsp; {mergeToDetails?.companyTypeName}
                                </div>
                                <div style={{ color: "#6c757d" }}>{mergeToDetails?.address1}</div>
                                <div style={{ color: "#6c757d" }}>{mergeToDetails?.city}{mergeToDetails?.state ? `, ${mergeToDetails.state}` : ""}</div>
                            </div>
                        </Col>
                        <Col md={2} className="d-flex justify-content-center align-items-center">
                            <div style={{
                                fontSize: 90,
                                fontWeight: 900,
                                lineHeight: 1,
                                color: "#28a745",
                                WebkitTextStroke: "3px #28a745",
                                textShadow: "0 3px 6px rgba(40,167,69,0.35)",
                            }}>&#10132;</div>
                        </Col>
                        <Col md={5}>
                            <div
                                style={{
                                    border: "1px solid #dee2e6",
                                    borderRadius: 6,
                                    padding: "10px 14px",
                                    fontSize: 13,
                                }}
                            >
                                <div style={{ fontWeight: 600, marginBottom: 2 }}>{mergeFromDetails?.companyName}</div>
                                <div style={{ fontSize: 11, color: "#6c757d", marginBottom: 6 }}>
                                    ID: {mergeFromDetails?.internalId}
                                </div>
                                <div style={{ color: "#6c757d" }}>{mergeFromDetails?.address1}</div>
                                <div style={{ color: "#6c757d" }}>{mergeFromDetails?.city}{mergeFromDetails?.state ? `, ${mergeFromDetails.state}` : ""}</div>
                            </div>
                        </Col>
                    </Row>
                    {!mergeResult && (
                        <div style={{ marginTop: 12, fontSize: 12, color: "#6c757d", textAlign: "center" }}>
                            The merge will be executed and an email sent to support to confirm.
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Container>
                        <Row>
                            <Col style={{ display: "flex", justifyContent: "left" }}>
                                <Button variant="secondary"
                                    onClick={() => {
                                        closeMergeConfirmModal();
                                    }}
                                >
                                    {mergeResult ? "Close" : "Cancel"}
                                </Button>
                            </Col>
                            {!mergeResult && (
                                <Col style={{ display: "flex", justifyContent: "right" }}>
                                    <Button
                                        onClick={handleMergeExecute}
                                        disabled={isMergeExecuting}
                                        style={hoveredBtn?.type === "mergeExecute"
                                            ? { ...btnGold, ...btnGoldHover }
                                            : { ...btnGold }}
                                        onMouseEnter={() => setHoveredBtn({ type: "mergeExecute" })}
                                        onMouseLeave={() => setHoveredBtn(null)}
                                    >
                                        {isMergeExecuting
                                            ? <><Spinner animation="border" size="sm" /> &nbsp;Merging...</>
                                            : "Confirm"}
                                    </Button>
                                </Col>
                            )}
                        </Row>
                    </Container>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AccountSettings;